export class FontAwesomeIconMapper {
  private iconMap: Map<string, string>;

  constructor() {
    this.iconMap = new Map<string, string>([
      ['30', '0'],
      ['31', '1'],
      ['32', '2'],
      ['33', '3'],
      ['34', '4'],
      ['35', '5'],
      ['36', '6'],
      ['37', '7'],
      ['38', '8'],
      ['39', '9'],
      ['e467', '00'],
      ['e2dc', '360-degrees'],
      ['e080', '42-group'],
      ['f26e', '500px'],
      ['41', 'a'],
      ['f640', 'abacus'],
      ['60', 'accent-grave'],
      ['f368', 'accessible-icon'],
      ['f369', 'accusoft'],
      ['f6ae', 'acorn'],
      ['f2b9', 'address-book'],
      ['f2bb', 'address-card'],
      ['f170', 'adn'],
      ['f36a', 'adversal'],
      ['f36b', 'affiliatetheme'],
      ['f8f4', 'air-conditioner'],
      ['f834', 'airbnb'],
      ['e089', 'airplay'],
      ['f34e', 'alarm-clock'],
      ['f843', 'alarm-exclamation'],
      ['f844', 'alarm-plus'],
      ['f845', 'alarm-snooze'],
      ['f89f', 'album'],
      ['e48c', 'album-circle-plus'],
      ['e48d', 'album-circle-user'],
      ['f8a0', 'album-collection'],
      ['e48e', 'album-collection-circle-plus'],
      ['e48f', 'album-collection-circle-user'],
      ['f36c', 'algolia'],
      ['f6b0', 'alicorn'],
      ['f8f5', 'alien'],
      ['f8f6', 'alien-8bit'],
      ['f037', 'align-center'],
      ['f039', 'align-justify'],
      ['f036', 'align-left'],
      ['f038', 'align-right'],
      ['f846', 'align-slash'],
      ['f642', 'alipay'],
      ['e08a', 'alt'],
      ['f270', 'amazon'],
      ['f42c', 'amazon-pay'],
      ['f36d', 'amilia'],
      ['f8a1', 'amp-guitar'],
      ['26', 'ampersand'],
      ['f13d', 'anchor'],
      ['e4aa', 'anchor-circle-check'],
      ['e4ab', 'anchor-circle-exclamation'],
      ['e4ac', 'anchor-circle-xmark'],
      ['e4ad', 'anchor-lock'],
      ['f17b', 'android'],
      ['f779', 'angel'],
      ['f209', 'angellist'],
      ['e08c', 'angle'],
      ['e08d', 'angle-90'],
      ['f107', 'angle-down'],
      ['f104', 'angle-left'],
      ['f105', 'angle-right'],
      ['f106', 'angle-up'],
      ['f103', 'angles-down'],
      ['f100', 'angles-left'],
      ['f101', 'angles-right'],
      ['f102', 'angles-up'],
      ['e60d', 'angles-up-down'],
      ['f36e', 'angry-creative'],
      ['f420', 'angular'],
      ['f644', 'ankh'],
      ['e680', 'ant'],
      ['e468', 'apartment'],
      ['e2df', 'aperture'],
      ['27', 'apostrophe'],
      ['f36f', 'app-store'],
      ['f370', 'ios-app-store'],
      ['f371', 'apper-systems-ab'],
      ['f179', 'apple'],
      ['e08f', 'apple-core'],
      ['f415', 'apple-pay'],
      ['f5d1', 'apple-whole'],
      ['f557', 'archway'],
      ['f063', 'arrow-down'],
      ['f162', 'arrow-down-1-9'],
      ['f886', 'arrow-down-9-1'],
      ['f15d', 'arrow-down-a-z'],
      ['f883', 'arrow-down-arrow-up'],
      ['f88c', 'arrow-down-big-small'],
      ['e614', 'arrow-down-from-arc'],
      ['e667', 'arrow-down-from-bracket'],
      ['e090', 'arrow-down-from-dotted-line'],
      ['f345', 'arrow-down-from-line'],
      ['e091', 'arrow-down-left'],
      ['e092', 'arrow-down-left-and-arrow-up-right-to-center'],
      ['f175', 'arrow-down-long'],
      ['e093', 'arrow-down-right'],
      ['f884', 'arrow-down-short-wide'],
      ['f88d', 'arrow-down-small-big'],
      ['f889', 'arrow-down-square-triangle'],
      ['e4ae', 'arrow-down-to-arc'],
      ['e094', 'arrow-down-to-bracket'],
      ['e095', 'arrow-down-to-dotted-line'],
      ['f33d', 'arrow-down-to-line'],
      ['e096', 'arrow-down-to-square'],
      ['f888', 'arrow-down-triangle-square'],
      ['e4af', 'arrow-down-up-across-line'],
      ['e4b0', 'arrow-down-up-lock'],
      ['f160', 'arrow-down-wide-short'],
      ['f881', 'arrow-down-z-a'],
      ['f060', 'arrow-left'],
      ['e615', 'arrow-left-from-arc'],
      ['e668', 'arrow-left-from-bracket'],
      ['f344', 'arrow-left-from-line'],
      ['f177', 'arrow-left-long'],
      ['e3d4', 'arrow-left-long-to-line'],
      ['e616', 'arrow-left-to-arc'],
      ['e669', 'arrow-left-to-bracket'],
      ['f33e', 'arrow-left-to-line'],
      ['f245', 'arrow-pointer'],
      ['e5df', 'arrow-progress'],
      ['f061', 'arrow-right'],
      ['f0ec', 'arrow-right-arrow-left'],
      ['e4b1', 'arrow-right-from-arc'],
      ['f08b', 'arrow-right-from-bracket'],
      ['f343', 'arrow-right-from-line'],
      ['f178', 'arrow-right-long'],
      ['e3d5', 'arrow-right-long-to-line'],
      ['e4b2', 'arrow-right-to-arc'],
      ['f090', 'arrow-right-to-bracket'],
      ['e4b3', 'arrow-right-to-city'],
      ['f340', 'arrow-right-to-line'],
      ['f0e2', 'arrow-rotate-left'],
      ['f01e', 'arrow-rotate-right'],
      ['e097', 'arrow-trend-down'],
      ['e098', 'arrow-trend-up'],
      ['f149', 'arrow-turn-down'],
      ['e2e1', 'arrow-turn-down-left'],
      ['e3d6', 'arrow-turn-down-right'],
      ['e632', 'arrow-turn-left'],
      ['e633', 'arrow-turn-left-down'],
      ['e634', 'arrow-turn-left-up'],
      ['e635', 'arrow-turn-right'],
      ['f148', 'arrow-turn-up'],
      ['f062', 'arrow-up'],
      ['f163', 'arrow-up-1-9'],
      ['f887', 'arrow-up-9-1'],
      ['f15e', 'arrow-up-a-z'],
      ['e099', 'arrow-up-arrow-down'],
      ['f88e', 'arrow-up-big-small'],
      ['e4b4', 'arrow-up-from-arc'],
      ['e09a', 'arrow-up-from-bracket'],
      ['e09b', 'arrow-up-from-dotted-line'],
      ['e4b5', 'arrow-up-from-ground-water'],
      ['f342', 'arrow-up-from-line'],
      ['e09c', 'arrow-up-from-square'],
      ['e4b6', 'arrow-up-from-water-pump'],
      ['e09d', 'arrow-up-left'],
      ['e09e', 'arrow-up-left-from-circle'],
      ['f176', 'arrow-up-long'],
      ['e09f', 'arrow-up-right'],
      ['e0a0', 'arrow-up-right-and-arrow-down-left-from-center'],
      ['e4b7', 'arrow-up-right-dots'],
      ['f08e', 'arrow-up-right-from-square'],
      ['f885', 'arrow-up-short-wide'],
      ['f88f', 'arrow-up-small-big'],
      ['f88b', 'arrow-up-square-triangle'],
      ['e617', 'arrow-up-to-arc'],
      ['e66a', 'arrow-up-to-bracket'],
      ['e0a1', 'arrow-up-to-dotted-line'],
      ['f341', 'arrow-up-to-line'],
      ['f88a', 'arrow-up-triangle-square'],
      ['f161', 'arrow-up-wide-short'],
      ['f882', 'arrow-up-z-a'],
      ['e0a2', 'arrows-cross'],
      ['e4b8', 'arrows-down-to-line'],
      ['e4b9', 'arrows-down-to-people'],
      ['e0a3', 'arrows-from-dotted-line'],
      ['e0a4', 'arrows-from-line'],
      ['f07e', 'arrows-left-right'],
      ['e4ba', 'arrows-left-right-to-line'],
      ['f31d', 'arrows-maximize'],
      ['e0a5', 'arrows-minimize'],
      ['f364', 'arrows-repeat'],
      ['f366', 'arrows-repeat-1'],
      ['f361', 'arrows-retweet'],
      ['f021', 'arrows-rotate'],
      ['e630', 'arrows-rotate-reverse'],
      ['e4bb', 'arrows-spin'],
      ['e4bc', 'arrows-split-up-and-left'],
      ['e4bd', 'arrows-to-circle'],
      ['e4be', 'arrows-to-dot'],
      ['e0a6', 'arrows-to-dotted-line'],
      ['e4bf', 'arrows-to-eye'],
      ['e0a7', 'arrows-to-line'],
      ['e4c0', 'arrows-turn-right'],
      ['e4c1', 'arrows-turn-to-dots'],
      ['f07d', 'arrows-up-down'],
      ['f047', 'arrows-up-down-left-right'],
      ['e4c2', 'arrows-up-to-line'],
      ['f77a', 'artstation'],
      ['2a', 'asterisk'],
      ['f372', 'asymmetrik'],
      ['40', 'at'],
      ['f77b', 'atlassian'],
      ['f5d2', 'atom'],
      ['f5d3', 'atom-simple'],
      ['f373', 'audible'],
      ['f29e', 'audio-description'],
      ['e0a8', 'audio-description-slash'],
      ['e0a9', 'austral-sign'],
      ['f41c', 'autoprefixer'],
      ['f374', 'avianex'],
      ['f421', 'aviato'],
      ['e0aa', 'avocado'],
      ['f559', 'award'],
      ['e0ab', 'award-simple'],
      ['f375', 'amazon-web-services-(aws)'],
      ['f6b2', 'axe'],
      ['f6b3', 'axe-battle'],
      ['42', 'b'],
      ['f77c', 'baby'],
      ['f77d', 'baby-carriage'],
      ['f5d4', 'backpack'],
      ['f04a', 'backward'],
      ['f049', 'backward-fast'],
      ['f048', 'backward-step'],
      ['f7e5', 'bacon'],
      ['e059', 'bacteria'],
      ['e05a', 'bacterium'],
      ['f335', 'badge'],
      ['f336', 'badge-check'],
      ['f645', 'badge-dollar'],
      ['f646', 'badge-percent'],
      ['f8a2', 'badge-sheriff'],
      ['f6b4', 'badger-honey'],
      ['e33a', 'badminton'],
      ['e5f2', 'bag-seedling'],
      ['f290', 'bag-shopping'],
      ['e650', 'bag-shopping-minus'],
      ['e651', 'bag-shopping-plus'],
      ['e3d7', 'bagel'],
      ['f847', 'bags-shopping'],
      ['e3d8', 'baguette'],
      ['f666', 'bahai'],
      ['e0ac', 'baht-sign'],
      ['f77e', 'ball-pile'],
      ['e2e3', 'balloon'],
      ['e2e4', 'balloons'],
      ['f732', 'ballot'],
      ['f733', 'ballot-check'],
      ['f05e', 'ban'],
      ['f7f9', 'ban-bug'],
      ['f616', 'ban-parking'],
      ['f54d', 'ban-smoking'],
      ['e2e5', 'banana'],
      ['f462', 'bandage'],
      ['f2d5', 'bandcamp'],
      ['e2e6', 'bangladeshi-taka-sign'],
      ['f8a3', 'banjo'],
      ['f02a', 'barcode'],
      ['f464', 'barcode-read'],
      ['f465', 'barcode-scan'],
      ['f0c9', 'bars'],
      ['e0ad', 'bars-filter'],
      ['f828', 'bars-progress'],
      ['e0ae', 'bars-sort'],
      ['f550', 'bars-staggered'],
      ['f433', 'baseball'],
      ['f432', 'baseball-bat-ball'],
      ['f291', 'basket-shopping'],
      ['e652', 'basket-shopping-minus'],
      ['e653', 'basket-shopping-plus'],
      ['e0af', 'basket-shopping-simple'],
      ['f434', 'basketball'],
      ['f435', 'basketball-hoop'],
      ['f6b5', 'bat'],
      ['f2cd', 'bath'],
      ['f376', 'battery-bolt'],
      ['f244', 'battery-empty'],
      ['e0b0', 'battery-exclamation'],
      ['f240', 'battery-full'],
      ['f242', 'battery-half'],
      ['e0b1', 'battery-low'],
      ['f243', 'battery-quarter'],
      ['f377', 'battery-slash'],
      ['f241', 'battery-three-quarters'],
      ['f236', 'bed'],
      ['f8f8', 'bed-bunk'],
      ['f8f9', 'bed-empty'],
      ['f8f7', 'bed-front'],
      ['f487', 'bed-pulse'],
      ['e0b2', 'bee'],
      ['e0b3', 'beer-mug'],
      ['f0fc', 'beer-mug-empty'],
      ['f1b4', 'behance'],
      ['f0f3', 'bell'],
      ['f562', 'bell-concierge'],
      ['f848', 'bell-exclamation'],
      ['f8fa', 'bell-on'],
      ['f849', 'bell-plus'],
      ['e62c', 'bell-ring'],
      ['f5d5', 'bell-school'],
      ['f5d6', 'bell-school-slash'],
      ['f1f6', 'bell-slash'],
      ['f77f', 'bells'],
      ['e2e7', 'bench-tree'],
      ['f55b', 'bezier-curve'],
      ['f206', 'bicycle'],
      ['e3d9', 'bilibili'],
      ['e5cd', 'billboard'],
      ['f378', 'bimobject'],
      ['e5f5', 'bin-bottles'],
      ['e5f6', 'bin-bottles-recycle'],
      ['e5f7', 'bin-recycle'],
      ['e33b', 'binary'],
      ['e33c', 'binary-circle-check'],
      ['e33d', 'binary-lock'],
      ['e33e', 'binary-slash'],
      ['f1e5', 'binoculars'],
      ['f780', 'biohazard'],
      ['e469', 'bird'],
      ['f171', 'bitbucket'],
      ['f379', 'bitcoin'],
      ['e0b4', 'bitcoin-sign'],
      ['f37a', 'bity'],
      ['f27e', 'font-awesome-black-tie'],
      ['f37b', 'blackberry'],
      ['f498', 'blanket'],
      ['e3da', 'blanket-fire'],
      ['f517', 'blender'],
      ['f6b6', 'blender-phone'],
      ['f8fb', 'blinds'],
      ['f8fc', 'blinds-open'],
      ['f8fd', 'blinds-raised'],
      ['e46a', 'block'],
      ['e3db', 'block-brick'],
      ['e3dc', 'block-brick-fire'],
      ['e3dd', 'block-question'],
      ['e0b5', 'block-quote'],
      ['f781', 'blog'],
      ['f37c', 'blogger'],
      ['f37d', 'blogger-b'],
      ['e2e8', 'blueberries'],
      ['e671', 'bluesky'],
      ['f293', 'bluetooth'],
      ['f294', 'bluetooth'],
      ['f032', 'bold'],
      ['f0e7', 'bolt'],
      ['e0b6', 'bolt-auto'],
      ['e0b7', 'bolt-lightning'],
      ['e0b8', 'bolt-slash'],
      ['f1e2', 'bomb'],
      ['f5d7', 'bone'],
      ['f5d8', 'bone-break'],
      ['f55c', 'bong'],
      ['f02d', 'book'],
      ['e0b9', 'book-arrow-right'],
      ['e0ba', 'book-arrow-up'],
      ['f558', 'book-atlas'],
      ['f647', 'book-bible'],
      ['f5d9', 'book-blank'],
      ['e0bb', 'book-bookmark'],
      ['e0bc', 'book-circle-arrow-right'],
      ['e0bd', 'book-circle-arrow-up'],
      ['e0be', 'book-copy'],
      ['e0bf', 'book-font'],
      ['f499', 'book-heart'],
      ['f66a', 'book-journal-whills'],
      ['f7e6', 'book-medical'],
      ['f518', 'book-open'],
      ['e0c0', 'book-open-cover'],
      ['f5da', 'book-open-reader'],
      ['f687', 'book-quran'],
      ['e0c1', 'book-section'],
      ['f6b7', 'book-skull'],
      ['f6b8', 'book-sparkles'],
      ['f827', 'book-tanakh'],
      ['f7e7', 'book-user'],
      ['f02e', 'bookmark'],
      ['e0c2', 'bookmark-slash'],
      ['f5db', 'books'],
      ['f7e8', 'books-medical'],
      ['f8a5', 'boombox'],
      ['f782', 'boot'],
      ['e33f', 'boot-heeled'],
      ['f734', 'booth-curtain'],
      ['f836', 'bootstrap'],
      ['f84c', 'border-all'],
      ['f84d', 'border-bottom'],
      ['f854', 'border-bottom-right'],
      ['f89c', 'border-center-h'],
      ['f89d', 'border-center-v'],
      ['f84e', 'border-inner'],
      ['f84f', 'border-left'],
      ['f850', 'border-none'],
      ['f851', 'border-outer'],
      ['f852', 'border-right'],
      ['f855', 'border-top'],
      ['f853', 'border-top-left'],
      ['e4c3', 'bore-hole'],
      ['e340', 'bots'],
      ['e673', 'bottle-baby'],
      ['e4c4', 'bottle-droplet'],
      ['e4c5', 'bottle-water'],
      ['f6b9', 'bow-arrow'],
      ['e2e9', 'bowl-chopsticks'],
      ['e2ea', 'bowl-chopsticks-noodles'],
      ['e4c6', 'bowl-food'],
      ['f823', 'bowl-hot'],
      ['e2eb', 'bowl-rice'],
      ['e3de', 'bowl-scoop'],
      ['e3df', 'bowl-scoops'],
      ['e46b', 'bowl-soft-serve'],
      ['e3e0', 'bowl-spoon'],
      ['f436', 'bowling-ball'],
      ['e0c3', 'bowling-ball-pin'],
      ['f437', 'bowling-pins'],
      ['f466', 'box'],
      ['f187', 'box-archive'],
      ['f735', 'box-ballot'],
      ['f467', 'box-check'],
      ['e0c4', 'box-circle-check'],
      ['f4a0', 'box-dollar'],
      ['f49d', 'box-heart'],
      ['f49e', 'box-open'],
      ['f49c', 'box-open-full'],
      ['f49a', 'box-taped'],
      ['e05b', 'box-tissue'],
      ['e4c7', 'boxes-packing'],
      ['f468', 'boxes-stacked'],
      ['f438', 'boxing-glove'],
      ['7b', 'bracket-curly'],
      ['7d', 'bracket-curly-right'],
      ['28', 'bracket-round'],
      ['29', 'bracket-round-right'],
      ['5b', 'bracket-square'],
      ['5d', 'bracket-square-right'],
      ['f7ea', 'brackets-curly'],
      ['e0c5', 'brackets-round'],
      ['f7e9', 'brackets-square'],
      ['f2a1', 'braille'],
      ['f5dc', 'brain'],
      ['f677', 'brain-arrow-curved-right'],
      ['e0c6', 'brain-circuit'],
      ['e0c7', 'brake-warning'],
      ['e63c', 'brave'],
      ['e63d', 'brave-reverse'],
      ['e46c', 'brazilian-real-sign'],
      ['f7eb', 'bread-loaf'],
      ['f7ec', 'bread-slice'],
      ['e3e1', 'bread-slice-butter'],
      ['e4c8', 'bridge'],
      ['e4c9', 'bridge-circle-check'],
      ['e4ca', 'bridge-circle-exclamation'],
      ['e4cb', 'bridge-circle-xmark'],
      ['e4cc', 'bridge-lock'],
      ['e4cd', 'bridge-suspension'],
      ['e4ce', 'bridge-water'],
      ['f0b1', 'briefcase'],
      ['e2f2', 'briefcase-arrow-right'],
      ['e0c8', 'briefcase-blank'],
      ['f469', 'briefcase-medical'],
      ['e0c9', 'brightness'],
      ['e0ca', 'brightness-low'],
      ['f856', 'bring-forward'],
      ['f857', 'bring-front'],
      ['e3e2', 'broccoli'],
      ['f51a', 'broom'],
      ['f458', 'broom-ball'],
      ['e5d1', 'broom-wide'],
      ['f37e', 'browser'],
      ['e0cb', 'browsers'],
      ['f55d', 'brush'],
      ['f15a', 'btc'],
      ['e4cf', 'bucket'],
      ['f837', 'buffer'],
      ['f188', 'bug'],
      ['e490', 'bug-slash'],
      ['e4d0', 'bugs'],
      ['f1ad', 'building'],
      ['e4d1', 'building-circle-arrow-right'],
      ['e4d2', 'building-circle-check'],
      ['e4d3', 'building-circle-exclamation'],
      ['e4d4', 'building-circle-xmark'],
      ['f19c', 'building-columns'],
      ['e4d5', 'building-flag'],
      ['e4d6', 'building-lock'],
      ['e61c', 'building-magnifying-glass'],
      ['e61e', 'building-memo'],
      ['e4d7', 'building-ngo'],
      ['e4d8', 'building-shield'],
      ['e4d9', 'building-un'],
      ['e4da', 'building-user'],
      ['e4db', 'building-wheat'],
      ['e0cc', 'buildings'],
      ['e655', 'bulldozer'],
      ['f0a1', 'bullhorn'],
      ['f140', 'bullseye'],
      ['f648', 'bullseye-arrow'],
      ['f649', 'bullseye-pointer'],
      ['e5b5', 'buoy'],
      ['e5b6', 'buoy-mooring'],
      ['f805', 'burger'],
      ['f7f1', 'burger-cheese'],
      ['e0cd', 'burger-fries'],
      ['e0ce', 'burger-glass'],
      ['e3e3', 'burger-lettuce'],
      ['f858', 'burger-soda'],
      ['f7ed', 'burrito'],
      ['e4dc', 'burst'],
      ['f207', 'bus'],
      ['f5dd', 'bus-school'],
      ['f55e', 'bus-simple'],
      ['f64a', 'business-time'],
      ['e3e4', 'butter'],
      ['f8a6', 'buy-n-large'],
      ['f20d', 'buysellads'],
      ['43', 'c'],
      ['e46d', 'cabin'],
      ['f64b', 'cabinet-filing'],
      ['f7da', 'cable-car'],
      ['f8a7', 'cactus'],
      ['e681', 'caduceus'],
      ['f1fd', 'cake-candles'],
      ['e3e5', 'cake-slice'],
      ['f1ec', 'calculator'],
      ['f64c', 'calculator-simple'],
      ['f133', 'calendar'],
      ['e0d0', 'calendar-arrow-down'],
      ['e0d1', 'calendar-arrow-up'],
      ['f274', 'calendar-check'],
      ['e46e', 'calendar-circle-exclamation'],
      ['e46f', 'calendar-circle-minus'],
      ['e470', 'calendar-circle-plus'],
      ['e471', 'calendar-circle-user'],
      ['e0d2', 'calendar-clock'],
      ['f783', 'calendar-day'],
      ['f073', 'calendar-days'],
      ['f334', 'calendar-exclamation'],
      ['e0d3', 'calendar-heart'],
      ['e0d4', 'calendar-image'],
      ['e0d5', 'calendar-lines'],
      ['e472', 'calendar-lines-pen'],
      ['f272', 'calendar-minus'],
      ['f333', 'calendar-pen'],
      ['f271', 'calendar-plus'],
      ['e0d6', 'calendar-range'],
      ['f736', 'calendar-star'],
      ['e5e2', 'calendar-users'],
      ['f784', 'calendar-week'],
      ['f273', 'calendar-xmark'],
      ['e0d7', 'calendars'],
      ['f8a8', 'camcorder'],
      ['f030', 'camera'],
      ['f8ac', 'camera-cctv'],
      ['f8a9', 'camera-movie'],
      ['f8aa', 'camera-polaroid'],
      ['f083', 'camera-retro'],
      ['e0d8', 'camera-rotate'],
      ['f8fe', 'camera-security'],
      ['e0d9', 'camera-slash'],
      ['e0da', 'camera-viewfinder'],
      ['f832', 'camera-web'],
      ['f833', 'camera-web-slash'],
      ['f6ba', 'campfire'],
      ['f6bb', 'campground'],
      ['e3e6', 'can-food'],
      ['f785', 'canadian-maple-leaf'],
      ['f6bc', 'candle-holder'],
      ['e3e7', 'candy'],
      ['e3e8', 'candy-bar'],
      ['f786', 'candy-cane'],
      ['f6bd', 'candy-corn'],
      ['f55f', 'cannabis'],
      ['e642', 'cannon'],
      ['f46b', 'capsules'],
      ['f1b9', 'car'],
      ['f5df', 'car-battery'],
      ['e341', 'car-bolt'],
      ['f859', 'car-building'],
      ['f5e0', 'car-bump'],
      ['f5e1', 'car-burst'],
      ['f85a', 'car-bus'],
      ['e342', 'car-circle-bolt'],
      ['f5e2', 'car-garage'],
      ['e343', 'car-mirrors'],
      ['e4dd', 'car-on'],
      ['f5de', 'car-rear'],
      ['f5e4', 'car-side'],
      ['e344', 'car-side-bolt'],
      ['f5e5', 'car-tilt'],
      ['e4de', 'car-tunnel'],
      ['f5e6', 'car-wash'],
      ['f5e3', 'car-wrench'],
      ['f8ff', 'caravan'],
      ['e000', 'caravan-simple'],
      ['e3e9', 'card-club'],
      ['e3ea', 'card-diamond'],
      ['e3eb', 'card-heart'],
      ['e3ec', 'card-spade'],
      ['e3ed', 'cards'],
      ['e4df', 'cards-blank'],
      ['f0d7', 'caret-down'],
      ['f0d9', 'caret-left'],
      ['f0da', 'caret-right'],
      ['f0d8', 'caret-up'],
      ['f787', 'carrot'],
      ['f85b', 'cars'],
      ['f218', 'cart-arrow-down'],
      ['e3ee', 'cart-arrow-up'],
      ['e3ef', 'cart-circle-arrow-down'],
      ['e3f0', 'cart-circle-arrow-up'],
      ['e3f1', 'cart-circle-check'],
      ['e3f2', 'cart-circle-exclamation'],
      ['e3f3', 'cart-circle-plus'],
      ['e3f4', 'cart-circle-xmark'],
      ['f474', 'cart-flatbed'],
      ['f475', 'cart-flatbed-boxes'],
      ['f476', 'cart-flatbed-empty'],
      ['f59d', 'cart-flatbed-suitcase'],
      ['e0db', 'cart-minus'],
      ['f217', 'cart-plus'],
      ['f07a', 'cart-shopping'],
      ['e0dc', 'cart-shopping-fast'],
      ['e0dd', 'cart-xmark'],
      ['f788', 'cash-register'],
      ['f8a4', 'cassette-betamax'],
      ['f8ab', 'cassette-tape'],
      ['f8ec', 'cassette-vhs'],
      ['e0de', 'castle'],
      ['f6be', 'cat'],
      ['e001', 'cat-space'],
      ['f6bf', 'cauldron'],
      ['f42d', 'amazon-pay-credit-card'],
      ['f1f3', 'cc-amex'],
      ['f416', 'apple-pay-credit-card'],
      ['f24c', "diner's-club-credit-card"],
      ['f1f2', 'discover-credit-card'],
      ['f24b', 'jcb-credit-card'],
      ['f1f1', 'mastercard-credit-card'],
      ['f1f4', 'paypal-credit-card'],
      ['f1f5', 'stripe-credit-card'],
      ['f1f0', 'visa-credit-card'],
      ['e0df', 'cedi-sign'],
      ['e3f5', 'cent-sign'],
      ['f380', 'centercode'],
      ['f789', 'centos'],
      ['f0a3', 'certificate'],
      ['f6c0', 'chair'],
      ['f6c1', 'chair-office'],
      ['f51b', 'chalkboard'],
      ['f51c', 'chalkboard-user'],
      ['f79e', 'champagne-glass'],
      ['f79f', 'champagne-glasses'],
      ['f5e7', 'charging-station'],
      ['f1fe', 'chart-area'],
      ['f080', 'chart-bar'],
      ['e0e1', 'chart-bullet'],
      ['e0e2', 'chart-candlestick'],
      ['e0e3', 'chart-column'],
      ['e0e4', 'chart-gantt'],
      ['e64f', 'chart-kanban'],
      ['f201', 'chart-line'],
      ['f64d', 'chart-line-down'],
      ['e0e5', 'chart-line-up'],
      ['e5d7', 'chart-line-up-down'],
      ['f643', 'chart-mixed'],
      ['e5d8', 'chart-mixed-up-circle-currency'],
      ['e5d9', 'chart-mixed-up-circle-dollar'],
      ['f78a', 'chart-network'],
      ['f200', 'chart-pie'],
      ['f64e', 'chart-pie-simple'],
      ['e604', 'chart-pie-simple-circle-currency'],
      ['e605', 'chart-pie-simple-circle-dollar'],
      ['e0e6', 'chart-pyramid'],
      ['e0e7', 'chart-radar'],
      ['f7ee', 'chart-scatter'],
      ['e0e8', 'chart-scatter-3d'],
      ['e0e9', 'chart-scatter-bubble'],
      ['e473', 'chart-simple'],
      ['e474', 'chart-simple-horizontal'],
      ['e0ea', 'chart-tree-map'],
      ['f6a3', 'chart-user'],
      ['e0eb', 'chart-waterfall'],
      ['f00c', 'check'],
      ['f560', 'check-double'],
      ['f772', 'check-to-slot'],
      ['f7ef', 'cheese'],
      ['f7f0', 'cheese-swiss'],
      ['e0ec', 'cherries'],
      ['f439', 'chess'],
      ['f43a', 'chess-bishop'],
      ['f43b', 'chess-bishop-piece'],
      ['f43c', 'chess-board'],
      ['f43d', 'chess-clock'],
      ['f43e', 'chess-clock-flip'],
      ['f43f', 'chess-king'],
      ['f440', 'chess-king-piece'],
      ['f441', 'chess-knight'],
      ['f442', 'chess-knight-piece'],
      ['f443', 'chess-pawn'],
      ['f444', 'chess-pawn-piece'],
      ['f445', 'chess-queen'],
      ['f446', 'chess-queen-piece'],
      ['f447', 'chess-rook'],
      ['f448', 'chess-rook-piece'],
      ['e3f6', 'chestnut'],
      ['f078', 'chevron-down'],
      ['f053', 'chevron-left'],
      ['f054', 'chevron-right'],
      ['f077', 'chevron-up'],
      ['f322', 'chevrons-down'],
      ['f323', 'chevrons-left'],
      ['f324', 'chevrons-right'],
      ['f325', 'chevrons-up'],
      ['e602', 'chf-sign'],
      ['f1ae', 'child'],
      ['e4e0', 'child-combatant'],
      ['e59c', 'child-dress'],
      ['e59d', 'child-reaching'],
      ['e4e1', 'children'],
      ['f78b', 'chimney'],
      ['e3f7', 'chopsticks'],
      ['f268', 'chrome'],
      ['f838', 'chromecast'],
      ['f51d', 'church'],
      ['f111', 'circle'],
      ['e0ed', 'circle-0'],
      ['e0ee', 'circle-1'],
      ['e0ef', 'circle-2'],
      ['e0f0', 'circle-3'],
      ['e0f1', 'circle-4'],
      ['e0f2', 'circle-5'],
      ['e0f3', 'circle-6'],
      ['e0f4', 'circle-7'],
      ['e0f5', 'circle-8'],
      ['e0f6', 'circle-9'],
      ['e0f7', 'circle-a'],
      ['e0f8', 'circle-ampersand'],
      ['f0ab', 'circle-arrow-down'],
      ['e0f9', 'circle-arrow-down-left'],
      ['e0fa', 'circle-arrow-down-right'],
      ['f0a8', 'circle-arrow-left'],
      ['f0a9', 'circle-arrow-right'],
      ['f0aa', 'circle-arrow-up'],
      ['e0fb', 'circle-arrow-up-left'],
      ['e0fc', 'circle-arrow-up-right'],
      ['e0fd', 'circle-b'],
      ['e0fe', 'circle-bolt'],
      ['e0ff', 'circle-book-open'],
      ['e100', 'circle-bookmark'],
      ['e101', 'circle-c'],
      ['e102', 'circle-calendar'],
      ['e103', 'circle-camera'],
      ['f32d', 'circle-caret-down'],
      ['f32e', 'circle-caret-left'],
      ['f330', 'circle-caret-right'],
      ['f331', 'circle-caret-up'],
      ['f058', 'circle-check'],
      ['f13a', 'circle-chevron-down'],
      ['f137', 'circle-chevron-left'],
      ['f138', 'circle-chevron-right'],
      ['f139', 'circle-chevron-up'],
      ['e104', 'circle-d'],
      ['e105', 'circle-dashed'],
      ['e106', 'circle-divide'],
      ['f2e8', 'circle-dollar'],
      ['f4b9', 'circle-dollar-to-slot'],
      ['f192', 'circle-dot'],
      ['f358', 'circle-down'],
      ['e107', 'circle-down-left'],
      ['e108', 'circle-down-right'],
      ['e109', 'circle-e'],
      ['e10a', 'circle-ellipsis'],
      ['e10b', 'circle-ellipsis-vertical'],
      ['e10c', 'circle-envelope'],
      ['e5ce', 'circle-euro'],
      ['f06a', 'circle-exclamation'],
      ['e10d', 'circle-exclamation-check'],
      ['e10e', 'circle-f'],
      ['e10f', 'circle-g'],
      ['e67f', 'circle-gf'],
      ['f47e', 'circle-h'],
      ['e110', 'circle-half'],
      ['f042', 'circle-half-stroke'],
      ['f4c7', 'circle-heart'],
      ['e111', 'circle-i'],
      ['f05a', 'circle-info'],
      ['e112', 'circle-j'],
      ['e113', 'circle-k'],
      ['e114', 'circle-l'],
      ['f359', 'circle-left'],
      ['f602', 'circle-location-arrow'],
      ['e115', 'circle-m'],
      ['e116', 'circle-microphone'],
      ['e117', 'circle-microphone-lines'],
      ['f056', 'circle-minus'],
      ['e118', 'circle-n'],
      ['e4e2', 'circle-nodes'],
      ['f1ce', 'circle-notch'],
      ['e119', 'circle-o'],
      ['e11a', 'circle-p'],
      ['f615', 'circle-parking'],
      ['f28b', 'circle-pause'],
      ['e11b', 'circle-phone'],
      ['e11c', 'circle-phone-flip'],
      ['e11d', 'circle-phone-hangup'],
      ['f144', 'circle-play'],
      ['f055', 'circle-plus'],
      ['e11e', 'circle-q'],
      ['e11f', 'circle-quarter'],
      ['e5d3', 'circle-quarter-stroke'],
      ['e3f8', 'circle-quarters'],
      ['f059', 'circle-question'],
      ['e120', 'circle-r'],
      ['f7ba', 'circle-radiation'],
      ['f35a', 'circle-right'],
      ['e121', 'circle-s'],
      ['e122', 'circle-small'],
      ['e030', 'circle-sort'],
      ['e031', 'circle-sort-down'],
      ['e032', 'circle-sort-up'],
      ['e123', 'circle-star'],
      ['e5cf', 'circle-sterling'],
      ['f28d', 'circle-stop'],
      ['e124', 'circle-t'],
      ['e125', 'circle-three-quarters'],
      ['e5d4', 'circle-three-quarters-stroke'],
      ['e126', 'circle-trash'],
      ['e127', 'circle-u'],
      ['f35b', 'circle-up'],
      ['e128', 'circle-up-left'],
      ['e129', 'circle-up-right'],
      ['f2bd', 'circle-user'],
      ['e12a', 'circle-v'],
      ['e12b', 'circle-video'],
      ['e12c', 'circle-w'],
      ['e12d', 'circle-waveform-lines'],
      ['e67d', 'circle-wifi'],
      ['e67e', 'circle-wifi-circle-wifi'],
      ['e12e', 'circle-x'],
      ['f057', 'circle-xmark'],
      ['e12f', 'circle-y'],
      ['e5d0', 'circle-yen'],
      ['e130', 'circle-z'],
      ['e600', 'circles-overlap'],
      ['e2f4', 'citrus'],
      ['e2f5', 'citrus-slice'],
      ['f64f', 'city'],
      ['e131', 'clapperboard'],
      ['e132', 'clapperboard-play'],
      ['f8ad', 'clarinet'],
      ['f6c2', 'claw-marks'],
      ['f328', 'clipboard'],
      ['f46c', 'clipboard-check'],
      ['f46d', 'clipboard-list'],
      ['f737', 'clipboard-list-check'],
      ['e133', 'clipboard-medical'],
      ['f5e8', 'clipboard-prescription'],
      ['e4e3', 'clipboard-question'],
      ['f7f3', 'clipboard-user'],
      ['f017', 'clock'],
      ['e134', 'clock-desk'],
      ['e345', 'clock-eight'],
      ['e346', 'clock-eight-thirty'],
      ['e347', 'clock-eleven'],
      ['e348', 'clock-eleven-thirty'],
      ['e349', 'clock-five'],
      ['e34a', 'clock-five-thirty'],
      ['e34b', 'clock-four-thirty'],
      ['e34c', 'clock-nine'],
      ['e34d', 'clock-nine-thirty'],
      ['e34e', 'clock-one'],
      ['e34f', 'clock-one-thirty'],
      ['f1da', 'clock-rotate-left'],
      ['e350', 'clock-seven'],
      ['e351', 'clock-seven-thirty'],
      ['e352', 'clock-six'],
      ['e353', 'clock-six-thirty'],
      ['e354', 'clock-ten'],
      ['e355', 'clock-ten-thirty'],
      ['e356', 'clock-three'],
      ['e357', 'clock-three-thirty'],
      ['e358', 'clock-twelve'],
      ['e359', 'clock-twelve-thirty'],
      ['e35a', 'clock-two'],
      ['e35b', 'clock-two-thirty'],
      ['f24d', 'clone'],
      ['f20a', 'closed-captioning'],
      ['e135', 'closed-captioning-slash'],
      ['e136', 'clothes-hanger'],
      ['f0c2', 'cloud'],
      ['f0ed', 'cloud-arrow-down'],
      ['f0ee', 'cloud-arrow-up'],
      ['e601', 'cloud-binary'],
      ['f76c', 'cloud-bolt'],
      ['f76d', 'cloud-bolt-moon'],
      ['f76e', 'cloud-bolt-sun'],
      ['e35c', 'cloud-check'],
      ['f738', 'cloud-drizzle'],
      ['e491', 'cloud-exclamation'],
      ['f74e', 'cloud-fog'],
      ['f739', 'cloud-hail'],
      ['f73a', 'cloud-hail-mixed'],
      ['f73b', 'cloud-meatball'],
      ['e35d', 'cloud-minus'],
      ['f6c3', 'cloud-moon'],
      ['f73c', 'cloud-moon-rain'],
      ['f8ae', 'cloud-music'],
      ['e35e', 'cloud-plus'],
      ['e492', 'cloud-question'],
      ['f73d', 'cloud-rain'],
      ['f73e', 'cloud-rainbow'],
      ['f73f', 'cloud-showers'],
      ['f740', 'cloud-showers-heavy'],
      ['e4e4', 'cloud-showers-water'],
      ['e137', 'cloud-slash'],
      ['f741', 'cloud-sleet'],
      ['f742', 'cloud-snow'],
      ['f6c4', 'cloud-sun'],
      ['f743', 'cloud-sun-rain'],
      ['e138', 'cloud-word'],
      ['e35f', 'cloud-xmark'],
      ['e07d', 'cloudflare'],
      ['f744', 'clouds'],
      ['f745', 'clouds-moon'],
      ['f746', 'clouds-sun'],
      ['f383', 'cloudscale'],
      ['f384', 'cloudsmith'],
      ['f385', 'cloudversify'],
      ['e139', 'clover'],
      ['f327', 'club'],
      ['e360', 'cmplid'],
      ['e2f6', 'coconut'],
      ['f121', 'code'],
      ['f126', 'code-branch'],
      ['f386', 'code-commit'],
      ['e13a', 'code-compare'],
      ['e13b', 'code-fork'],
      ['f387', 'code-merge'],
      ['e13c', 'code-pull-request'],
      ['e3f9', 'code-pull-request-closed'],
      ['e3fa', 'code-pull-request-draft'],
      ['e13d', 'code-simple'],
      ['f1cb', 'codepen'],
      ['f284', 'codie-pie'],
      ['e13e', 'coffee-bean'],
      ['e13f', 'coffee-beans'],
      ['e002', 'coffee-pot'],
      ['f6c6', 'coffin'],
      ['e051', 'coffin-cross'],
      ['f85c', 'coin'],
      ['e3fb', 'coin-blank'],
      ['e3fc', 'coin-front'],
      ['e3fd', 'coin-vertical'],
      ['f51e', 'coins'],
      ['3a', 'colon'],
      ['e140', 'colon-sign'],
      ['e361', 'columns-3'],
      ['e003', 'comet'],
      ['2c', 'comma'],
      ['e142', 'command'],
      ['f075', 'comment'],
      ['e143', 'comment-arrow-down'],
      ['e144', 'comment-arrow-up'],
      ['e145', 'comment-arrow-up-right'],
      ['e146', 'comment-captions'],
      ['f4ac', 'comment-check'],
      ['e147', 'comment-code'],
      ['f651', 'comment-dollar'],
      ['f4ad', 'comment-dots'],
      ['f4af', 'comment-exclamation'],
      ['e5c8', 'comment-heart'],
      ['e148', 'comment-image'],
      ['f4b0', 'comment-lines'],
      ['f7f5', 'comment-medical'],
      ['e149', 'comment-middle'],
      ['e14a', 'comment-middle-top'],
      ['f4b1', 'comment-minus'],
      ['f8b0', 'comment-music'],
      ['f4ae', 'comment-pen'],
      ['f4b2', 'comment-plus'],
      ['e14b', 'comment-question'],
      ['e14c', 'comment-quote'],
      ['f4b3', 'comment-slash'],
      ['f4b4', 'comment-smile'],
      ['f7cd', 'comment-sms'],
      ['e14d', 'comment-text'],
      ['f4b5', 'comment-xmark'],
      ['f086', 'comments'],
      ['f653', 'comments-dollar'],
      ['e14e', 'comments-question'],
      ['e14f', 'comments-question-check'],
      ['f51f', 'compact-disc'],
      ['f14e', 'compass'],
      ['f568', 'compass-drafting'],
      ['f5e9', 'compass-slash'],
      ['f066', 'compress'],
      ['f326', 'compress-wide'],
      ['e4e5', 'computer'],
      ['f8b1', 'computer-classic'],
      ['f8cc', 'computer-mouse'],
      ['f8cd', 'computer-mouse-scrollwheel'],
      ['f8b2', 'computer-speaker'],
      ['f78d', 'confluence'],
      ['f20e', 'connect-develop'],
      ['f4b7', 'container-storage'],
      ['f26d', 'contao'],
      ['f46e', 'conveyor-belt'],
      ['e5f8', 'conveyor-belt-arm'],
      ['f46f', 'conveyor-belt-boxes'],
      ['e150', 'conveyor-belt-empty'],
      ['f563', 'cookie'],
      ['f564', 'cookie-bite'],
      ['f0c5', 'copy'],
      ['f1f9', 'copyright'],
      ['f6c7', 'corn'],
      ['e3fe', 'corner'],
      ['f89e', 'cotton-bureau'],
      ['f4b8', 'couch'],
      ['e643', 'court-sport'],
      ['f6c8', 'cow'],
      ['f8b3', 'cowbell'],
      ['f8b4', 'cowbell-circle-plus'],
      ['f388', 'cpanel'],
      ['e3ff', 'crab'],
      ['f6b1', 'crate-apple'],
      ['e151', 'crate-empty'],
      ['f25e', 'creative-commons'],
      ['f4e7', 'creative-commons-attribution'],
      ['f4e8', 'creative-commons-noncommercial'],
      ['f4e9', 'creative-commons-noncommercial-(euro-sign)'],
      ['f4ea', 'creative-commons-noncommercial-(yen-sign)'],
      ['f4eb', 'creative-commons-no-derivative-works'],
      ['f4ec', 'creative-commons-public-domain'],
      ['f4ed', 'alternate-creative-commons-public-domain'],
      ['f4ee', 'creative-commons-remix'],
      ['f4ef', 'creative-commons-share-alike'],
      ['f4f0', 'creative-commons-sampling'],
      ['f4f1', 'creative-commons-sampling-+'],
      ['f4f2', 'creative-commons-share'],
      ['f4f3', 'creative-commons-cc0'],
      ['f09d', 'credit-card'],
      ['f389', 'credit-card-blank'],
      ['f38a', 'credit-card-front'],
      ['f449', 'cricket-bat-ball'],
      ['f6c9', 'critical-role'],
      ['f7f6', 'croissant'],
      ['f125', 'crop'],
      ['f565', 'crop-simple'],
      ['f654', 'cross'],
      ['f05b', 'crosshairs'],
      ['e59f', 'crosshairs-simple'],
      ['f520', 'crow'],
      ['f521', 'crown'],
      ['f7f7', 'crutch'],
      ['f7f8', 'crutches'],
      ['e152', 'cruzeiro-sign'],
      ['e362', 'crystal-ball'],
      ['f13c', 'css-3-logo'],
      ['f38b', 'alternate-css3-logo'],
      ['f1b2', 'cube'],
      ['f1b3', 'cubes'],
      ['e4e6', 'cubes-stacked'],
      ['e401', 'cucumber'],
      ['e363', 'cup-straw'],
      ['e364', 'cup-straw-swoosh'],
      ['f6c5', 'cup-togo'],
      ['e402', 'cupcake'],
      ['f44a', 'curling-stone'],
      ['e403', 'custard'],
      ['f38c', 'cuttlefish'],
      ['44', 'd'],
      ['f38d', 'dungeons-&-dragons'],
      ['f6ca', 'd&d-beyond'],
      ['f6cb', 'dagger'],
      ['e052', 'dailymotion'],
      ['e693', 'dart-lang'],
      ['e404', 'dash'],
      ['f210', 'dashcube'],
      ['f1c0', 'database'],
      ['e60b', 'debian'],
      ['f78e', 'deer'],
      ['f78f', 'deer-rudolph'],
      ['e077', 'deezer'],
      ['f55a', 'delete-left'],
      ['e154', 'delete-right'],
      ['f1a5', 'delicious'],
      ['f747', 'democrat'],
      ['f38e', 'deploydog'],
      ['f38f', 'deskpro'],
      ['f390', 'desktop'],
      ['e155', 'desktop-arrow-down'],
      ['f6cc', 'dev'],
      ['f1bd', 'deviantart'],
      ['f655', 'dharmachakra'],
      ['f790', 'dhl'],
      ['e475', 'diagram-cells'],
      ['e156', 'diagram-lean-canvas'],
      ['e157', 'diagram-nested'],
      ['e476', 'diagram-next'],
      ['e477', 'diagram-predecessor'],
      ['e478', 'diagram-previous'],
      ['f542', 'diagram-project'],
      ['e158', 'diagram-sankey'],
      ['e479', 'diagram-subtask'],
      ['e47a', 'diagram-successor'],
      ['e15a', 'diagram-venn'],
      ['e15b', 'dial'],
      ['e15c', 'dial-high'],
      ['e15d', 'dial-low'],
      ['e15e', 'dial-max'],
      ['e15f', 'dial-med'],
      ['e160', 'dial-med-low'],
      ['e161', 'dial-min'],
      ['e162', 'dial-off'],
      ['f219', 'diamond'],
      ['e405', 'diamond-exclamation'],
      ['e5b7', 'diamond-half'],
      ['e5b8', 'diamond-half-stroke'],
      ['f5eb', 'diamond-turn-right'],
      ['e68b', 'diamonds-4'],
      ['f791', 'diaspora'],
      ['f522', 'dice'],
      ['f6cd', 'dice-d10'],
      ['f6ce', 'dice-d12'],
      ['f6cf', 'dice-d20'],
      ['f6d0', 'dice-d4'],
      ['f6d1', 'dice-d6'],
      ['f6d2', 'dice-d8'],
      ['f523', 'dice-five'],
      ['f524', 'dice-four'],
      ['f525', 'dice-one'],
      ['f526', 'dice-six'],
      ['f527', 'dice-three'],
      ['f528', 'dice-two'],
      ['f1a6', 'digg-logo'],
      ['f391', 'digital-ocean'],
      ['e5fe', 'dinosaur'],
      ['f5ea', 'diploma'],
      ['f8b5', 'disc-drive'],
      ['f392', 'discord'],
      ['f393', 'discourse'],
      ['f7fa', 'disease'],
      ['e163', 'display'],
      ['e164', 'display-arrow-down'],
      ['e5e3', 'display-chart-up'],
      ['e5e5', 'display-chart-up-circle-currency'],
      ['e5e6', 'display-chart-up-circle-dollar'],
      ['e165', 'display-code'],
      ['e166', 'display-medical'],
      ['e2fa', 'display-slash'],
      ['e365', 'distribute-spacing-horizontal'],
      ['e366', 'distribute-spacing-vertical'],
      ['22', 'ditto'],
      ['f529', 'divide'],
      ['f471', 'dna'],
      ['f5ec', 'do-not-enter'],
      ['f394', 'dochub'],
      ['f395', 'docker'],
      ['f6d3', 'dog'],
      ['f6d4', 'dog-leashed'],
      ['24', 'dollar-sign'],
      ['f472', 'dolly'],
      ['f473', 'dolly-empty'],
      ['e168', 'dolphin'],
      ['e169', 'dong-sign'],
      ['e406', 'donut'],
      ['f52a', 'door-closed'],
      ['f52b', 'door-open'],
      ['f4ba', 'dove'],
      ['f354', 'down'],
      ['e66b', 'down-from-bracket'],
      ['e407', 'down-from-dotted-line'],
      ['f349', 'down-from-line'],
      ['e16a', 'down-left'],
      ['f422', 'down-left-and-up-right-to-center'],
      ['f309', 'down-long'],
      ['e16b', 'down-right'],
      ['e4e7', 'down-to-bracket'],
      ['e408', 'down-to-dotted-line'],
      ['f34a', 'down-to-line'],
      ['f019', 'download'],
      ['f396', 'draft2digital'],
      ['f6d5', 'dragon'],
      ['f5ed', 'draw-circle'],
      ['f5ee', 'draw-polygon'],
      ['f5ef', 'draw-square'],
      ['f792', 'dreidel'],
      ['f17d', 'dribbble'],
      ['f85f', 'drone'],
      ['f860', 'drone-front'],
      ['f16b', 'dropbox'],
      ['f043', 'droplet'],
      ['f748', 'droplet-degree'],
      ['f750', 'droplet-percent'],
      ['f5c7', 'droplet-slash'],
      ['f569', 'drum'],
      ['f56a', 'drum-steelpan'],
      ['f6d6', 'drumstick'],
      ['f6d7', 'drumstick-bite'],
      ['f1a9', 'drupal-logo'],
      ['f861', 'dryer'],
      ['f862', 'dryer-heat'],
      ['f6d8', 'duck'],
      ['f44b', 'dumbbell'],
      ['f793', 'dumpster'],
      ['f794', 'dumpster-fire'],
      ['f6d9', 'dungeon'],
      ['f399', 'dyalog'],
      ['45', 'e'],
      ['f5f0', 'ear'],
      ['f2a4', 'ear-deaf'],
      ['f2a2', 'ear-listen'],
      ['f795', 'ear-muffs'],
      ['f39a', 'earlybirds'],
      ['f57c', 'earth-africa'],
      ['f57d', 'earth-americas'],
      ['f57e', 'earth-asia'],
      ['f7a2', 'earth-europe'],
      ['e47b', 'earth-oceania'],
      ['f4f4', 'ebay'],
      ['f749', 'eclipse'],
      ['f282', 'edge-browser'],
      ['e078', 'edge-legacy-browser'],
      ['f7fb', 'egg'],
      ['f7fc', 'egg-fried'],
      ['e16c', 'eggplant'],
      ['f052', 'eject'],
      ['f430', 'elementor'],
      ['f6da', 'elephant'],
      ['e16d', 'elevator'],
      ['f141', 'ellipsis'],
      ['f39b', 'ellipsis-stroke'],
      ['f39c', 'ellipsis-stroke-vertical'],
      ['f142', 'ellipsis-vertical'],
      ['f5f1', 'ello'],
      ['f423', 'ember'],
      ['f1d1', 'galactic-empire'],
      ['f656', 'empty-set'],
      ['e16e', 'engine'],
      ['f5f2', 'engine-warning'],
      ['f0e0', 'envelope'],
      ['e4e8', 'envelope-circle-check'],
      ['e16f', 'envelope-dot'],
      ['f2b6', 'envelope-open'],
      ['f657', 'envelope-open-dollar'],
      ['f658', 'envelope-open-text'],
      ['e170', 'envelopes'],
      ['f674', 'envelopes-bulk'],
      ['f299', 'envira-gallery'],
      ['3d', 'equals'],
      ['f12d', 'eraser'],
      ['f39d', 'erlang'],
      ['e171', 'escalator'],
      ['f42e', 'ethereum'],
      ['f796', 'ethernet'],
      ['f2d7', 'etsy'],
      ['f153', 'euro-sign'],
      ['f839', 'evernote'],
      ['e656', 'excavator'],
      ['21', 'exclamation'],
      ['f065', 'expand'],
      ['f320', 'expand-wide'],
      ['f23e', 'expeditedssl'],
      ['e4e9', 'explosion'],
      ['f06e', 'eye'],
      ['f1fb', 'eye-dropper'],
      ['e172', 'eye-dropper-full'],
      ['e173', 'eye-dropper-half'],
      ['f6db', 'eye-evil'],
      ['f2a8', 'eye-low-vision'],
      ['f070', 'eye-slash'],
      ['e367', 'eyes'],
      ['46', 'f'],
      ['f556', 'face-angry'],
      ['e368', 'face-angry-horns'],
      ['e369', 'face-anguished'],
      ['e36a', 'face-anxious-sweat'],
      ['e36b', 'face-astonished'],
      ['e409', 'face-awesome'],
      ['e47c', 'face-beam-hand-over-mouth'],
      ['e47d', 'face-clouds'],
      ['e36c', 'face-confounded'],
      ['e36d', 'face-confused'],
      ['e36e', 'face-cowboy-hat'],
      ['e47e', 'face-diagonal-mouth'],
      ['e36f', 'face-disappointed'],
      ['e370', 'face-disguise'],
      ['f567', 'face-dizzy'],
      ['e47f', 'face-dotted'],
      ['e371', 'face-downcast-sweat'],
      ['e372', 'face-drooling'],
      ['e480', 'face-exhaling'],
      ['e2fe', 'face-explode'],
      ['e373', 'face-expressionless'],
      ['e374', 'face-eyes-xmarks'],
      ['e375', 'face-fearful'],
      ['f579', 'face-flushed'],
      ['f119', 'face-frown'],
      ['f57a', 'face-frown-open'],
      ['e376', 'face-frown-slight'],
      ['e377', 'face-glasses'],
      ['f57f', 'face-grimace'],
      ['f580', 'face-grin'],
      ['f582', 'face-grin-beam'],
      ['f583', 'face-grin-beam-sweat'],
      ['f584', 'face-grin-hearts'],
      ['f585', 'face-grin-squint'],
      ['f586', 'face-grin-squint-tears'],
      ['f587', 'face-grin-stars'],
      ['f588', 'face-grin-tears'],
      ['f589', 'face-grin-tongue'],
      ['f58a', 'face-grin-tongue-squint'],
      ['f58b', 'face-grin-tongue-wink'],
      ['f581', 'face-grin-wide'],
      ['f58c', 'face-grin-wink'],
      ['e378', 'face-hand-over-mouth'],
      ['e481', 'face-hand-peeking'],
      ['e379', 'face-hand-yawn'],
      ['e37a', 'face-head-bandage'],
      ['e482', 'face-holding-back-tears'],
      ['e37b', 'face-hushed'],
      ['e37c', 'face-icicles'],
      ['f596', 'face-kiss'],
      ['f597', 'face-kiss-beam'],
      ['e37d', 'face-kiss-closed-eyes'],
      ['f598', 'face-kiss-wink-heart'],
      ['f599', 'face-laugh'],
      ['f59a', 'face-laugh-beam'],
      ['f59b', 'face-laugh-squint'],
      ['f59c', 'face-laugh-wink'],
      ['e37e', 'face-lying'],
      ['e37f', 'face-mask'],
      ['f11a', 'face-meh'],
      ['f5a4', 'face-meh-blank'],
      ['e483', 'face-melting'],
      ['e380', 'face-monocle'],
      ['e381', 'face-nauseated'],
      ['e382', 'face-nose-steam'],
      ['e383', 'face-party'],
      ['e384', 'face-pensive'],
      ['e385', 'face-persevering'],
      ['e386', 'face-pleading'],
      ['e387', 'face-pouting'],
      ['e388', 'face-raised-eyebrow'],
      ['e389', 'face-relieved'],
      ['f5a5', 'face-rolling-eyes'],
      ['f5b3', 'face-sad-cry'],
      ['e38a', 'face-sad-sweat'],
      ['f5b4', 'face-sad-tear'],
      ['e484', 'face-saluting'],
      ['e38b', 'face-scream'],
      ['e38c', 'face-shush'],
      ['e38d', 'face-sleeping'],
      ['e38e', 'face-sleepy'],
      ['f118', 'face-smile'],
      ['f5b8', 'face-smile-beam'],
      ['e38f', 'face-smile-halo'],
      ['e390', 'face-smile-hearts'],
      ['e391', 'face-smile-horns'],
      ['f5b9', 'face-smile-plus'],
      ['e392', 'face-smile-relaxed'],
      ['e393', 'face-smile-tear'],
      ['e394', 'face-smile-tongue'],
      ['e395', 'face-smile-upside-down'],
      ['f4da', 'face-smile-wink'],
      ['e396', 'face-smiling-hands'],
      ['e397', 'face-smirking'],
      ['e485', 'face-spiral-eyes'],
      ['e398', 'face-sunglasses'],
      ['f5c2', 'face-surprise'],
      ['e399', 'face-swear'],
      ['e39a', 'face-thermometer'],
      ['e39b', 'face-thinking'],
      ['f5c8', 'face-tired'],
      ['e39c', 'face-tissue'],
      ['e39d', 'face-tongue-money'],
      ['e39e', 'face-tongue-sweat'],
      ['e39f', 'face-unamused'],
      ['e2ff', 'face-viewfinder'],
      ['e3a0', 'face-vomit'],
      ['e3a1', 'face-weary'],
      ['e3a2', 'face-woozy'],
      ['e3a3', 'face-worried'],
      ['e3a4', 'face-zany'],
      ['e3a5', 'face-zipper'],
      ['f09a', 'facebook'],
      ['f39e', 'facebook-f'],
      ['f39f', 'facebook-messenger'],
      ['e40a', 'falafel'],
      ['e300', 'family'],
      ['e301', 'family-dress'],
      ['e302', 'family-pants'],
      ['f863', 'fan'],
      ['e004', 'fan-table'],
      ['f6dc', 'fantasy-flight-games'],
      ['f864', 'farm'],
      ['e005', 'faucet'],
      ['e006', 'faucet-drip'],
      ['f1ac', 'fax'],
      ['f52d', 'feather'],
      ['f56b', 'feather-pointed'],
      ['f797', 'fedex'],
      ['f798', 'fedora'],
      ['e303', 'fence'],
      ['e174', 'ferris-wheel'],
      ['e4ea', 'ferry'],
      ['f44c', 'field-hockey-stick-ball'],
      ['f799', 'figma'],
      ['f15b', 'file'],
      ['f56d', 'file-arrow-down'],
      ['f574', 'file-arrow-up'],
      ['f1c7', 'file-audio'],
      ['e175', 'file-binary'],
      ['e672', 'file-cad'],
      ['f5f3', 'file-certificate'],
      ['f659', 'file-chart-column'],
      ['f65a', 'file-chart-pie'],
      ['f316', 'file-check'],
      ['e5a0', 'file-circle-check'],
      ['e4eb', 'file-circle-exclamation'],
      ['e493', 'file-circle-info'],
      ['e4ed', 'file-circle-minus'],
      ['e494', 'file-circle-plus'],
      ['e4ef', 'file-circle-question'],
      ['e5a1', 'file-circle-xmark'],
      ['f1c9', 'file-code'],
      ['f56c', 'file-contract'],
      ['f6dd', 'file-csv'],
      ['f877', 'file-dashed-line'],
      ['e5ed', 'file-doc'],
      ['e644', 'file-eps'],
      ['f1c3', 'file-excel'],
      ['f31a', 'file-exclamation'],
      ['f56e', 'file-export'],
      ['e645', 'file-gif'],
      ['e176', 'file-heart'],
      ['f1c5', 'file-image'],
      ['f56f', 'file-import'],
      ['f570', 'file-invoice'],
      ['f571', 'file-invoice-dollar'],
      ['e646', 'file-jpg'],
      ['f15c', 'file-lines'],
      ['e3a6', 'file-lock'],
      ['f865', 'file-magnifying-glass'],
      ['f477', 'file-medical'],
      ['f318', 'file-minus'],
      ['e647', 'file-mov'],
      ['e648', 'file-mp3'],
      ['e649', 'file-mp4'],
      ['f8b6', 'file-music'],
      ['f1c1', 'file-pdf'],
      ['f31c', 'file-pen'],
      ['f319', 'file-plus'],
      ['e177', 'file-plus-minus'],
      ['e666', 'file-png'],
      ['f1c4', 'file-powerpoint'],
      ['e64a', 'file-ppt'],
      ['f572', 'file-prescription'],
      ['e4f0', 'file-shield'],
      ['f573', 'file-signature'],
      ['e3a7', 'file-slash'],
      ['f65b', 'file-spreadsheet'],
      ['e64b', 'file-svg'],
      ['f65c', 'file-user'],
      ['e64c', 'file-vector'],
      ['f1c8', 'file-video'],
      ['f478', 'file-waveform'],
      ['f1c2', 'file-word'],
      ['e64d', 'file-xls'],
      ['f317', 'file-xmark'],
      ['e654', 'file-xml'],
      ['e5ee', 'file-zip'],
      ['f1c6', 'file-zipper'],
      ['e178', 'files'],
      ['f7fd', 'files-medical'],
      ['f575', 'fill'],
      ['f576', 'fill-drip'],
      ['f008', 'film'],
      ['f8b7', 'film-canister'],
      ['f3a0', 'film-simple'],
      ['e179', 'film-slash'],
      ['e17a', 'films'],
      ['f0b0', 'filter'],
      ['f662', 'filter-circle-dollar'],
      ['e17b', 'filter-circle-xmark'],
      ['e17c', 'filter-list'],
      ['e17d', 'filter-slash'],
      ['e17e', 'filters'],
      ['f577', 'fingerprint'],
      ['f06d', 'fire'],
      ['e4f1', 'fire-burner'],
      ['f134', 'fire-extinguisher'],
      ['f6df', 'fire-flame'],
      ['f7e4', 'fire-flame-curved'],
      ['f46a', 'fire-flame-simple'],
      ['e17f', 'fire-hydrant'],
      ['f74b', 'fire-smoke'],
      ['f269', 'firefox'],
      ['e007', 'firefox-browser'],
      ['f79a', 'fireplace'],
      ['f2b0', 'first-order'],
      ['f50a', 'alternate-first-order'],
      ['f3a1', 'firstdraft'],
      ['f578', 'fish'],
      ['e304', 'fish-bones'],
      ['f7fe', 'fish-cooked'],
      ['e4f2', 'fish-fins'],
      ['e3a8', 'fishing-rod'],
      ['f024', 'flag'],
      ['f11e', 'flag-checkered'],
      ['f456', 'flag-pennant'],
      ['f74c', 'flag-swallowtail'],
      ['f74d', 'flag-usa'],
      ['f8b8', 'flashlight'],
      ['f0c3', 'flask'],
      ['e5f1', 'flask-gear'],
      ['f6e0', 'flask-round-poison'],
      ['f6e1', 'flask-round-potion'],
      ['e4f3', 'flask-vial'],
      ['e40b', 'flatbread'],
      ['e40c', 'flatbread-stuffed'],
      ['f16e', 'flickr'],
      ['f44d', 'flipboard'],
      ['f0c7', 'floppy-disk'],
      ['e180', 'floppy-disk-circle-arrow-right'],
      ['e181', 'floppy-disk-circle-xmark'],
      ['e182', 'floppy-disk-pen'],
      ['e183', 'floppy-disks'],
      ['e184', 'florin-sign'],
      ['f7ff', 'flower'],
      ['f800', 'flower-daffodil'],
      ['f801', 'flower-tulip'],
      ['f8b9', 'flute'],
      ['e694', 'flutter'],
      ['f8ba', 'flux-capacitor'],
      ['f417', 'fly'],
      ['e3a9', 'flying-disc'],
      ['f07b', 'folder'],
      ['e053', 'folder-arrow-down'],
      ['e054', 'folder-arrow-up'],
      ['e186', 'folder-bookmark'],
      ['e64e', 'folder-check'],
      ['e185', 'folder-closed'],
      ['e187', 'folder-gear'],
      ['e188', 'folder-grid'],
      ['e189', 'folder-heart'],
      ['e18a', 'folder-image'],
      ['e18b', 'folder-magnifying-glass'],
      ['e18c', 'folder-medical'],
      ['f65d', 'folder-minus'],
      ['e18d', 'folder-music'],
      ['f07c', 'folder-open'],
      ['f65e', 'folder-plus'],
      ['f802', 'folder-tree'],
      ['e18e', 'folder-user'],
      ['f65f', 'folder-xmark'],
      ['f660', 'folders'],
      ['e40d', 'fondue-pot'],
      ['f031', 'font'],
      ['f2b4', 'font-awesome'],
      ['f866', 'font-case'],
      ['f280', 'fonticons'],
      ['f3a2', 'fonticons-fi'],
      ['f44e', 'football'],
      ['f44f', 'football-helmet'],
      ['f2e3', 'fork'],
      ['f2e6', 'fork-knife'],
      ['f47a', 'forklift'],
      ['e486', 'fort'],
      ['f286', 'fort-awesome'],
      ['f3a3', 'alternate-fort-awesome'],
      ['f211', 'forumbee'],
      ['f04e', 'forward'],
      ['f050', 'forward-fast'],
      ['f051', 'forward-step'],
      ['f180', 'foursquare'],
      ['e495', 'frame'],
      ['e18f', 'franc-sign'],
      ['f2c5', 'freecodecamp'],
      ['f3a4', 'freebsd'],
      ['f803', 'french-fries'],
      ['f52e', 'frog'],
      ['f50b', 'fulcrum'],
      ['f661', 'function'],
      ['f1e3', 'futbol'],
      ['47', 'g'],
      ['f50c', 'galactic-republic'],
      ['f50d', 'galactic-senate'],
      ['e008', 'galaxy'],
      ['e3aa', 'gallery-thumbnails'],
      ['f867', 'game-board'],
      ['f868', 'game-board-simple'],
      ['f8bb', 'game-console-handheld'],
      ['e5b9', 'game-console-handheld-crank'],
      ['f11b', 'gamepad'],
      ['e5a2', 'gamepad-modern'],
      ['e009', 'garage'],
      ['e00a', 'garage-car'],
      ['e00b', 'garage-open'],
      ['e40e', 'garlic'],
      ['f52f', 'gas-pump'],
      ['f5f4', 'gas-pump-slash'],
      ['f624', 'gauge'],
      ['e496', 'gauge-circle-bolt'],
      ['e497', 'gauge-circle-minus'],
      ['e498', 'gauge-circle-plus'],
      ['f625', 'gauge-high'],
      ['f627', 'gauge-low'],
      ['f626', 'gauge-max'],
      ['f628', 'gauge-min'],
      ['f629', 'gauge-simple'],
      ['f62a', 'gauge-simple-high'],
      ['f62c', 'gauge-simple-low'],
      ['f62b', 'gauge-simple-max'],
      ['f62d', 'gauge-simple-min'],
      ['f0e3', 'gavel'],
      ['f013', 'gear'],
      ['e5e8', 'gear-code'],
      ['e5e9', 'gear-complex'],
      ['e5eb', 'gear-complex-code'],
      ['f085', 'gears'],
      ['f3a5', 'gem'],
      ['f22d', 'genderless'],
      ['f265', 'get-pocket'],
      ['f260', 'gg-currency'],
      ['f261', 'gg-currency-circle'],
      ['f6e2', 'ghost'],
      ['e190', 'gif'],
      ['f06b', 'gift'],
      ['f663', 'gift-card'],
      ['f79c', 'gifts'],
      ['f79d', 'gingerbread-man'],
      ['f1d3', 'git'],
      ['f841', 'git-alt'],
      ['f09b', 'github'],
      ['f113', 'alternate-github'],
      ['f3a6', 'gitkraken'],
      ['f296', 'gitlab'],
      ['f426', 'gitter'],
      ['f804', 'glass'],
      ['f869', 'glass-citrus'],
      ['e191', 'glass-empty'],
      ['e192', 'glass-half'],
      ['e4f4', 'glass-water'],
      ['e4f5', 'glass-water-droplet'],
      ['f530', 'glasses'],
      ['f5f5', 'glasses-round'],
      ['f2a5', 'glide'],
      ['f2a6', 'glide-g'],
      ['f0ac', 'globe'],
      ['e60e', 'globe-pointer'],
      ['f7a3', 'globe-snow'],
      ['f5f6', 'globe-stand'],
      ['e685', 'globe-wifi'],
      ['e3ab', 'goal-net'],
      ['f3a7', 'gofore'],
      ['e40f', 'go'],
      ['f450', 'golf-ball-tee'],
      ['f451', 'golf-club'],
      ['e3ac', 'golf-flag-hole'],
      ['f3a8', 'goodreads'],
      ['f3a9', 'goodreads-g'],
      ['f1a0', 'google-logo'],
      ['f3aa', 'google-drive'],
      ['e079', 'google-pay'],
      ['f3ab', 'google-play'],
      ['f2b3', 'google-plus'],
      ['f0d5', 'google-plus-g'],
      ['e63b', 'google-scholar'],
      ['f1ee', 'google-wallet'],
      ['f664', 'gopuram'],
      ['f19d', 'graduation-cap'],
      ['f8bd', 'gramophone'],
      ['e306', 'grapes'],
      ['e193', 'grate'],
      ['e194', 'grate-droplet'],
      ['f184', 'gratipay-(gittip)'],
      ['f2d6', 'grav'],
      ['3e', 'greater-than'],
      ['f532', 'greater-than-equal'],
      ['e195', 'grid'],
      ['e196', 'grid-2'],
      ['e197', 'grid-2-plus'],
      ['e198', 'grid-4'],
      ['e199', 'grid-5'],
      ['e3ad', 'grid-dividers'],
      ['e307', 'grid-horizontal'],
      ['e5da', 'grid-round'],
      ['e5db', 'grid-round-2'],
      ['e5dc', 'grid-round-2-plus'],
      ['e5dd', 'grid-round-4'],
      ['e5de', 'grid-round-5'],
      ['e5a3', 'grill'],
      ['e5a4', 'grill-fire'],
      ['e5a5', 'grill-hot'],
      ['f58d', 'grip'],
      ['e410', 'grip-dots'],
      ['e411', 'grip-dots-vertical'],
      ['f7a4', 'grip-lines'],
      ['f7a5', 'grip-lines-vertical'],
      ['f58e', 'grip-vertical'],
      ['f3ac', 'gripfire'],
      ['e4f6', 'group-arrows-rotate'],
      ['f3ad', 'grunt'],
      ['e19a', 'guarani-sign'],
      ['e07e', 'guilded'],
      ['f7a6', 'guitar'],
      ['f8be', 'guitar-electric'],
      ['f8bf', 'guitars'],
      ['f3ae', 'gulp'],
      ['e19b', 'gun'],
      ['e19c', 'gun-slash'],
      ['e19d', 'gun-squirt'],
      ['48', 'h'],
      ['f313', 'h1'],
      ['f314', 'h2'],
      ['f315', 'h3'],
      ['f86a', 'h4'],
      ['e412', 'h5'],
      ['e413', 'h6'],
      ['f1d4', 'hacker-news'],
      ['f5f7', 'hackerrank'],
      ['f6e3', 'hammer'],
      ['e620', 'hammer-brush'],
      ['e414', 'hammer-crash'],
      ['f6e4', 'hammer-war'],
      ['f665', 'hamsa'],
      ['f256', 'hand'],
      ['f255', 'hand-back-fist'],
      ['e19e', 'hand-back-point-down'],
      ['e19f', 'hand-back-point-left'],
      ['e1a0', 'hand-back-point-ribbon'],
      ['e1a1', 'hand-back-point-right'],
      ['e1a2', 'hand-back-point-up'],
      ['f461', 'hand-dots'],
      ['e1a3', 'hand-fingers-crossed'],
      ['f6de', 'hand-fist'],
      ['f4bc', 'hand-heart'],
      ['f4bd', 'hand-holding'],
      ['f47b', 'hand-holding-box'],
      ['e621', 'hand-holding-circle-dollar'],
      ['f4c0', 'hand-holding-dollar'],
      ['f4c1', 'hand-holding-droplet'],
      ['e4f7', 'hand-holding-hand'],
      ['f4be', 'hand-holding-heart'],
      ['f6e5', 'hand-holding-magic'],
      ['e05c', 'hand-holding-medical'],
      ['f4bf', 'hand-holding-seedling'],
      ['e1a4', 'hand-holding-skull'],
      ['e1a9', 'hand-horns'],
      ['f258', 'hand-lizard'],
      ['e1a5', 'hand-love'],
      ['f806', 'hand-middle-finger'],
      ['f25b', 'hand-peace'],
      ['f0a7', 'hand-point-down'],
      ['f0a5', 'hand-point-left'],
      ['e1a6', 'hand-point-ribbon'],
      ['f0a4', 'hand-point-right'],
      ['f0a6', 'hand-point-up'],
      ['f25a', 'hand-pointer'],
      ['f257', 'hand-scissors'],
      ['e05d', 'hand-sparkles'],
      ['f259', 'hand-spock'],
      ['e1a7', 'hand-wave'],
      ['e4f8', 'handcuffs'],
      ['f2a7', 'hands'],
      ['f2a3', 'hands-asl-interpreting'],
      ['e4f9', 'hands-bound'],
      ['e05e', 'hands-bubbles'],
      ['e1a8', 'hands-clapping'],
      ['f4c2', 'hands-holding'],
      ['e4fa', 'hands-holding-child'],
      ['e4fb', 'hands-holding-circle'],
      ['f47c', 'hands-holding-diamond'],
      ['f4c5', 'hands-holding-dollar'],
      ['f4c3', 'hands-holding-heart'],
      ['f684', 'hands-praying'],
      ['f2b5', 'handshake'],
      ['f4c4', 'handshake-angle'],
      ['f4c6', 'handshake-simple'],
      ['e05f', 'handshake-simple-slash'],
      ['e060', 'handshake-slash'],
      ['f6e6', 'hanukiah'],
      ['f0a0', 'hard-drive'],
      ['e499', 'hashnode'],
      ['23', 'hashtag'],
      ['e415', 'hashtag-lock'],
      ['e606', 'hat-beach'],
      ['f86b', 'hat-chef'],
      ['f8c0', 'hat-cowboy'],
      ['f8c1', 'hat-cowboy-side'],
      ['f7a7', 'hat-santa'],
      ['f7a8', 'hat-winter'],
      ['f6e7', 'hat-witch'],
      ['f6e8', 'hat-wizard'],
      ['f6e9', 'head-side'],
      ['f808', 'head-side-brain'],
      ['e061', 'head-side-cough'],
      ['e062', 'head-side-cough-slash'],
      ['e611', 'head-side-gear'],
      ['f6ea', 'head-side-goggles'],
      ['f8c2', 'head-side-headphones'],
      ['e1aa', 'head-side-heart'],
      ['e063', 'head-side-mask'],
      ['f809', 'head-side-medical'],
      ['e064', 'head-side-virus'],
      ['f1dc', 'heading'],
      ['f025', 'headphones'],
      ['f58f', 'headphones-simple'],
      ['f590', 'headset'],
      ['f004', 'heart'],
      ['e4fc', 'heart-circle-bolt'],
      ['e4fd', 'heart-circle-check'],
      ['e4fe', 'heart-circle-exclamation'],
      ['e4ff', 'heart-circle-minus'],
      ['e500', 'heart-circle-plus'],
      ['e501', 'heart-circle-xmark'],
      ['f7a9', 'heart-crack'],
      ['e1ab', 'heart-half'],
      ['e1ac', 'heart-half-stroke'],
      ['f21e', 'heart-pulse'],
      ['e00c', 'heat'],
      ['f533', 'helicopter'],
      ['e502', 'helicopter-symbol'],
      ['f6eb', 'helmet-battle'],
      ['f807', 'helmet-safety'],
      ['e503', 'helmet-un'],
      ['f312', 'hexagon'],
      ['e416', 'hexagon-check'],
      ['e1ad', 'hexagon-divide'],
      ['e417', 'hexagon-exclamation'],
      ['e504', 'hexagon-image'],
      ['f307', 'hexagon-minus'],
      ['f300', 'hexagon-plus'],
      ['e505', 'hexagon-vertical-nft'],
      ['e506', 'hexagon-vertical-nft-slanted'],
      ['f2ee', 'hexagon-xmark'],
      ['e1ae', 'high-definition'],
      ['f591', 'highlighter'],
      ['e1af', 'highlighter-line'],
      ['e507', 'hill-avalanche'],
      ['e508', 'hill-rockslide'],
      ['f6ed', 'hippo'],
      ['f452', 'hips'],
      ['f3b0', 'hireahelper'],
      ['e07f', 'hive-blockchain-network'],
      ['f6ee', 'hockey-mask'],
      ['f453', 'hockey-puck'],
      ['e3ae', 'hockey-stick-puck'],
      ['f454', 'hockey-sticks'],
      ['f7aa', 'holly-berry'],
      ['e418', 'honey-pot'],
      ['f6ef', 'hood-cloak'],
      ['f427', 'hooli'],
      ['f86c', 'horizontal-rule'],
      ['f592', 'hornbill'],
      ['f6f0', 'horse'],
      ['f7ab', 'horse-head'],
      ['f8c3', 'horse-saddle'],
      ['e419', 'hose'],
      ['e41a', 'hose-reel'],
      ['f0f8', 'hospital'],
      ['f80d', 'hospital-user'],
      ['f80e', 'hospitals'],
      ['f593', 'hot-tub-person'],
      ['f80f', 'hotdog'],
      ['f594', 'hotel'],
      ['f3b1', 'hotjar'],
      ['f254', 'hourglass'],
      ['e41b', 'hourglass-clock'],
      ['f253', 'hourglass-end'],
      ['f252', 'hourglass-half'],
      ['f251', 'hourglass-start'],
      ['f015', 'house'],
      ['e487', 'house-blank'],
      ['e1b1', 'house-building'],
      ['e3af', 'house-chimney'],
      ['e3b0', 'house-chimney-blank'],
      ['f6f1', 'house-chimney-crack'],
      ['e1b2', 'house-chimney-heart'],
      ['f7f2', 'house-chimney-medical'],
      ['e065', 'house-chimney-user'],
      ['e00d', 'house-chimney-window'],
      ['e509', 'house-circle-check'],
      ['e50a', 'house-circle-exclamation'],
      ['e50b', 'house-circle-xmark'],
      ['e3b1', 'house-crack'],
      ['e00e', 'house-day'],
      ['e50c', 'house-fire'],
      ['e50d', 'house-flag'],
      ['e50e', 'house-flood-water'],
      ['e50f', 'house-flood-water-circle-arrow-right'],
      ['f4c9', 'house-heart'],
      ['e066', 'house-laptop'],
      ['e510', 'house-lock'],
      ['e3b2', 'house-medical'],
      ['e511', 'house-medical-circle-check'],
      ['e512', 'house-medical-circle-exclamation'],
      ['e513', 'house-medical-circle-xmark'],
      ['e514', 'house-medical-flag'],
      ['e010', 'house-night'],
      ['e00f', 'house-person-leave'],
      ['e011', 'house-person-return'],
      ['e012', 'house-signal'],
      ['e1b3', 'house-tree'],
      ['e515', 'house-tsunami'],
      ['e1b4', 'house-turret'],
      ['e1b0', 'house-user'],
      ['f74f', 'house-water'],
      ['e3b3', 'house-window'],
      ['f27c', 'houzz'],
      ['f6f2', 'hryvnia-sign'],
      ['f13b', 'html-5-logo'],
      ['f3b2', 'hubspot'],
      ['e41c', 'hundred-points'],
      ['f751', 'hurricane'],
      ['e686', 'hydra'],
      ['2d', 'hyphen'],
      ['49', 'i'],
      ['f246', 'i-cursor'],
      ['f810', 'ice-cream'],
      ['f7ac', 'ice-skate'],
      ['f7ad', 'icicles'],
      ['f86d', 'icons'],
      ['f2c1', 'id-badge'],
      ['f2c2', 'id-card'],
      ['f47f', 'id-card-clip'],
      ['e013', 'ideal'],
      ['f7ae', 'igloo'],
      ['f03e', 'image'],
      ['e1b5', 'image-landscape'],
      ['f8c4', 'image-polaroid'],
      ['e1b6', 'image-polaroid-user'],
      ['f3e0', 'image-portrait'],
      ['e1b7', 'image-slash'],
      ['e1b8', 'image-user'],
      ['f302', 'images'],
      ['e1b9', 'images-user'],
      ['f2d8', 'imdb'],
      ['f01c', 'inbox'],
      ['e1ba', 'inbox-full'],
      ['f310', 'inbox-in'],
      ['f311', 'inbox-out'],
      ['e1bb', 'inboxes'],
      ['f03c', 'indent'],
      ['e1bc', 'indian-rupee-sign'],
      ['f275', 'industry'],
      ['f3b3', 'industry-windows'],
      ['f534', 'infinity'],
      ['f129', 'info'],
      ['f5f9', 'inhaler'],
      ['e1bd', 'input-numeric'],
      ['e1be', 'input-pipe'],
      ['e1bf', 'input-text'],
      ['f16d', 'instagram'],
      ['e081', 'instalod'],
      ['f667', 'integral'],
      ['f7af', 'intercom'],
      ['f26b', 'internet-explorer'],
      ['e5ba', 'interrobang'],
      ['f668', 'intersection'],
      ['f7b0', 'invision'],
      ['f208', 'ioxhost'],
      ['f811', 'island-tropical'],
      ['f033', 'italic'],
      ['f83a', 'itch-io'],
      ['f3b4', 'itunes'],
      ['f3b5', 'itunes-note'],
      ['4a', 'j'],
      ['f30e', 'jack-o-lantern'],
      ['e516', 'jar'],
      ['e517', 'jar-wheat'],
      ['f4e4', 'java'],
      ['f669', 'jedi'],
      ['f50e', 'jedi-order'],
      ['f3b6', 'jenkis'],
      ['f0fb', 'jet-fighter'],
      ['e518', 'jet-fighter-up'],
      ['f7b1', 'jira'],
      ['f3b7', 'joget'],
      ['f595', 'joint'],
      ['f1aa', 'joomla-logo'],
      ['f8c5', 'joystick'],
      ['f3b8', 'javascript-(js)'],
      ['f1cc', 'jsfiddle'],
      ['f8c6', 'jug'],
      ['e5fb', 'jug-bottle'],
      ['e519', 'jug-detergent'],
      ['e67b', 'jxl'],
      ['4b', 'k'],
      ['f66b', 'kaaba'],
      ['f5fa', 'kaggle'],
      ['f8c7', 'kazoo'],
      ['f86f', 'kerning'],
      ['f084', 'key'],
      ['f6f3', 'key-skeleton'],
      ['e3b4', 'key-skeleton-left-right'],
      ['f4f5', 'keybase'],
      ['f11c', 'keyboard'],
      ['e1c0', 'keyboard-brightness'],
      ['e1c1', 'keyboard-brightness-low'],
      ['e1c2', 'keyboard-down'],
      ['e1c3', 'keyboard-left'],
      ['f3ba', 'keycdn'],
      ['f66c', 'keynote'],
      ['f66d', 'khanda'],
      ['f3bb', 'kickstarter'],
      ['f3bc', 'kickstarter-k'],
      ['f5fb', 'kidneys'],
      ['e1c4', 'kip-sign'],
      ['f479', 'kit-medical'],
      ['e51a', 'kitchen-set'],
      ['f6f4', 'kite'],
      ['f535', 'kiwi-bird'],
      ['e30c', 'kiwi-fruit'],
      ['f2e4', 'knife'],
      ['f6f5', 'knife-kitchen'],
      ['f42f', 'korvue'],
      ['4c', 'l'],
      ['e3b5', 'lacrosse-stick'],
      ['e3b6', 'lacrosse-stick-ball'],
      ['f66e', 'lambda'],
      ['f4ca', 'lamp'],
      ['e014', 'lamp-desk'],
      ['e015', 'lamp-floor'],
      ['e1c5', 'lamp-street'],
      ['e51b', 'land-mine-on'],
      ['f66f', 'landmark'],
      ['f752', 'landmark-dome'],
      ['e51c', 'landmark-flag'],
      ['e622', 'landmark-magnifying-glass'],
      ['f1ab', 'language'],
      ['f109', 'laptop'],
      ['e1c6', 'laptop-arrow-down'],
      ['e5e7', 'laptop-binary'],
      ['f5fc', 'laptop-code'],
      ['e51d', 'laptop-file'],
      ['f812', 'laptop-medical'],
      ['f87a', 'laptop-mobile'],
      ['e1c7', 'laptop-slash'],
      ['f3bd', 'laravel'],
      ['e1c8', 'lari-sign'],
      ['f8c8', 'lasso'],
      ['e1c9', 'lasso-sparkles'],
      ['f202', 'lastfm'],
      ['f5fd', 'layer-group'],
      ['f5fe', 'layer-minus'],
      ['f5ff', 'layer-plus'],
      ['f06c', 'leaf'],
      ['f4cb', 'leaf-heart'],
      ['f6f6', 'leaf-maple'],
      ['f6f7', 'leaf-oak'],
      ['e41d', 'leafy-green'],
      ['f212', 'leanpub'],
      ['f355', 'left'],
      ['e66c', 'left-from-bracket'],
      ['f348', 'left-from-line'],
      ['f30a', 'left-long'],
      ['e41e', 'left-long-to-line'],
      ['f337', 'left-right'],
      ['e66d', 'left-to-bracket'],
      ['f34b', 'left-to-line'],
      ['f094', 'lemon'],
      ['f41d', 'less'],
      ['3c', 'less-than'],
      ['f537', 'less-than-equal'],
      ['e62d', 'letterboxd'],
      ['f1cd', 'life-ring'],
      ['e016', 'light-ceiling'],
      ['e41f', 'light-emergency'],
      ['e420', 'light-emergency-on'],
      ['e017', 'light-switch'],
      ['e018', 'light-switch-off'],
      ['e019', 'light-switch-on'],
      ['f0eb', 'lightbulb'],
      ['e5a6', 'lightbulb-cfl'],
      ['e5a7', 'lightbulb-cfl-on'],
      ['f670', 'lightbulb-dollar'],
      ['f671', 'lightbulb-exclamation'],
      ['e1ca', 'lightbulb-exclamation-on'],
      ['e5fd', 'lightbulb-gear'],
      ['e687', 'lightbulb-message'],
      ['f672', 'lightbulb-on'],
      ['f673', 'lightbulb-slash'],
      ['e612', 'lighthouse'],
      ['f7b2', 'lights-holiday'],
      ['f3c0', 'line'],
      ['f870', 'line-columns'],
      ['f871', 'line-height'],
      ['e51e', 'lines-leaning'],
      ['f0c1', 'link'],
      ['e1cb', 'link-horizontal'],
      ['e1cc', 'link-horizontal-slash'],
      ['e1cd', 'link-simple'],
      ['e1ce', 'link-simple-slash'],
      ['f127', 'link-slash'],
      ['f08c', 'linkedin'],
      ['f0e1', 'linkedin-in'],
      ['f2b8', 'linode'],
      ['f17c', 'linux'],
      ['f600', 'lips'],
      ['f195', 'lira-sign'],
      ['f03a', 'list'],
      ['f0ae', 'list-check'],
      ['e1cf', 'list-dropdown'],
      ['f8c9', 'list-music'],
      ['f0cb', 'list-ol'],
      ['e1d0', 'list-radio'],
      ['e1d1', 'list-timeline'],
      ['e1d2', 'list-tree'],
      ['f0ca', 'list-ul'],
      ['e1d3', 'litecoin-sign'],
      ['e1d4', 'loader'],
      ['e421', 'lobster'],
      ['f124', 'location-arrow'],
      ['e63a', 'location-arrow-up'],
      ['f606', 'location-check'],
      ['f601', 'location-crosshairs'],
      ['f603', 'location-crosshairs-slash'],
      ['f3c5', 'location-dot'],
      ['f605', 'location-dot-slash'],
      ['f608', 'location-exclamation'],
      ['f609', 'location-minus'],
      ['f607', 'location-pen'],
      ['f041', 'location-pin'],
      ['e51f', 'location-pin-lock'],
      ['f60c', 'location-pin-slash'],
      ['f60a', 'location-plus'],
      ['f60b', 'location-question'],
      ['f60d', 'location-smile'],
      ['f60e', 'location-xmark'],
      ['f023', 'lock'],
      ['e422', 'lock-a'],
      ['e423', 'lock-hashtag'],
      ['f30d', 'lock-keyhole'],
      ['f3c2', 'lock-keyhole-open'],
      ['f3c1', 'lock-open'],
      ['e520', 'locust'],
      ['e424', 'lollipop'],
      ['f4cc', 'loveseat'],
      ['f455', 'luchador-mask'],
      ['f604', 'lungs'],
      ['e067', 'lungs-virus'],
      ['f3c3', 'lyft'],
      ['4d', 'm'],
      ['f6f8', 'mace'],
      ['f3c4', 'magento'],
      ['f076', 'magnet'],
      ['f002', 'magnifying-glass'],
      ['e521', 'magnifying-glass-arrow-right'],
      ['e65e', 'magnifying-glass-arrows-rotate'],
      ['e522', 'magnifying-glass-chart'],
      ['f688', 'magnifying-glass-dollar'],
      ['f689', 'magnifying-glass-location'],
      ['f010', 'magnifying-glass-minus'],
      ['e65f', 'magnifying-glass-music'],
      ['e660', 'magnifying-glass-play'],
      ['f00e', 'magnifying-glass-plus'],
      ['e661', 'magnifying-glass-waveform'],
      ['f813', 'mailbox'],
      ['e5bb', 'mailbox-flag-up'],
      ['f59e', 'mailchimp'],
      ['e1d5', 'manat-sign'],
      ['f50f', 'mandalorian'],
      ['f6f9', 'mandolin'],
      ['e30f', 'mango'],
      ['e1d6', 'manhole'],
      ['f279', 'map'],
      ['f59f', 'map-location'],
      ['f5a0', 'map-location-dot'],
      ['f276', 'map-pin'],
      ['f60f', 'markdown'],
      ['f5a1', 'marker'],
      ['f222', 'mars'],
      ['f224', 'mars-and-venus'],
      ['e523', 'mars-and-venus-burst'],
      ['f227', 'mars-double'],
      ['f229', 'mars-stroke'],
      ['f22b', 'mars-stroke-right'],
      ['f22a', 'mars-stroke-up'],
      ['f57b', 'martini-glass'],
      ['f561', 'martini-glass-citrus'],
      ['f000', 'martini-glass-empty'],
      ['f6fa', 'mask'],
      ['e1d7', 'mask-face'],
      ['e3b7', 'mask-snorkel'],
      ['e524', 'mask-ventilator'],
      ['f630', 'masks-theater'],
      ['f4f6', 'mastodon'],
      ['e525', 'mattress-pillow'],
      ['f136', 'maxcdn'],
      ['f31e', 'maximize'],
      ['f8ca', 'material-design-for-bootstrap'],
      ['f814', 'meat'],
      ['f5a2', 'medal'],
      ['f3c6', 'medapps'],
      ['f23a', 'medium'],
      ['f3c8', 'mrt'],
      ['f2e0', 'meetup'],
      ['f675', 'megaphone'],
      ['f5a3', 'megaport'],
      ['e310', 'melon'],
      ['e311', 'melon-slice'],
      ['e1d8', 'memo'],
      ['e1d9', 'memo-circle-check'],
      ['e49a', 'memo-circle-info'],
      ['e1da', 'memo-pad'],
      ['f538', 'memory'],
      ['f7b3', 'mendeley'],
      ['f676', 'menorah'],
      ['f223', 'mercury'],
      ['e526', 'merge'],
      ['f27a', 'message'],
      ['e1db', 'message-arrow-down'],
      ['e1dc', 'message-arrow-up'],
      ['e1dd', 'message-arrow-up-right'],
      ['e3b8', 'message-bot'],
      ['e1de', 'message-captions'],
      ['f4a2', 'message-check'],
      ['e1df', 'message-code'],
      ['f650', 'message-dollar'],
      ['f4a3', 'message-dots'],
      ['f4a5', 'message-exclamation'],
      ['e5c9', 'message-heart'],
      ['e1e0', 'message-image'],
      ['f4a6', 'message-lines'],
      ['f7f4', 'message-medical'],
      ['e1e1', 'message-middle'],
      ['e1e2', 'message-middle-top'],
      ['f4a7', 'message-minus'],
      ['f8af', 'message-music'],
      ['f4a4', 'message-pen'],
      ['f4a8', 'message-plus'],
      ['e1e3', 'message-question'],
      ['e1e4', 'message-quote'],
      ['f4a9', 'message-slash'],
      ['f4aa', 'message-smile'],
      ['e1e5', 'message-sms'],
      ['e1e6', 'message-text'],
      ['f4ab', 'message-xmark'],
      ['f4b6', 'messages'],
      ['f652', 'messages-dollar'],
      ['e1e7', 'messages-question'],
      ['e49b', 'meta'],
      ['f753', 'meteor'],
      ['e1e8', 'meter'],
      ['e1e9', 'meter-bolt'],
      ['e1ea', 'meter-droplet'],
      ['e1eb', 'meter-fire'],
      ['e01a', 'microblog'],
      ['f2db', 'microchip'],
      ['e1ec', 'microchip-ai'],
      ['f130', 'microphone'],
      ['f3c9', 'microphone-lines'],
      ['f539', 'microphone-lines-slash'],
      ['f131', 'microphone-slash'],
      ['f8cb', 'microphone-stand'],
      ['f610', 'microscope'],
      ['f3ca', 'microsoft'],
      ['e01b', 'microwave'],
      ['e1ed', 'mill-sign'],
      ['f78c', 'minimize'],
      ['e62f', 'mintbit'],
      ['f068', 'minus'],
      ['f7b4', 'mistletoe'],
      ['f7b5', 'mitten'],
      ['f3cb', 'mix'],
      ['f289', 'mixcloud'],
      ['e056', 'mixer'],
      ['f3cc', 'mizuni'],
      ['f3ce', 'mobile'],
      ['f10b', 'mobile-button'],
      ['e1ee', 'mobile-notch'],
      ['e527', 'mobile-retro'],
      ['f3cf', 'mobile-screen'],
      ['f3cd', 'mobile-screen-button'],
      ['e1ef', 'mobile-signal'],
      ['e1f0', 'mobile-signal-out'],
      ['f285', 'modx'],
      ['f3d0', 'monero'],
      ['f0d6', 'money-bill'],
      ['f3d1', 'money-bill-1'],
      ['f53b', 'money-bill-1-wave'],
      ['e1f1', 'money-bill-simple'],
      ['e1f2', 'money-bill-simple-wave'],
      ['e528', 'money-bill-transfer'],
      ['e529', 'money-bill-trend-up'],
      ['f53a', 'money-bill-wave'],
      ['e52a', 'money-bill-wheat'],
      ['e1f3', 'money-bills'],
      ['e1f4', 'money-bills-simple'],
      ['f53c', 'money-check'],
      ['f53d', 'money-check-dollar'],
      ['f873', 'money-check-dollar-pen'],
      ['f872', 'money-check-pen'],
      ['e312', 'money-from-bracket'],
      ['e313', 'money-simple-from-bracket'],
      ['f611', 'monitor-waveform'],
      ['f6fb', 'monkey'],
      ['f5a6', 'monument'],
      ['f186', 'moon'],
      ['f754', 'moon-cloud'],
      ['f74a', 'moon-over-sun'],
      ['f755', 'moon-stars'],
      ['e3b9', 'moped'],
      ['f5a7', 'mortar-pestle'],
      ['f678', 'mosque'],
      ['e52b', 'mosquito'],
      ['e52c', 'mosquito-net'],
      ['f21c', 'motorcycle'],
      ['e52d', 'mound'],
      ['f6fc', 'mountain'],
      ['e52e', 'mountain-city'],
      ['e52f', 'mountain-sun'],
      ['f6fd', 'mountains'],
      ['e5a8', 'mouse-field'],
      ['f8ce', 'mp3-player'],
      ['f874', 'mug'],
      ['f7b6', 'mug-hot'],
      ['f7b7', 'mug-marshmallows'],
      ['f0f4', 'mug-saucer'],
      ['f875', 'mug-tea'],
      ['e1f5', 'mug-tea-saucer'],
      ['e425', 'mushroom'],
      ['f001', 'music'],
      ['e662', 'music-magnifying-glass'],
      ['f8cf', 'music-note'],
      ['f8d0', 'music-note-slash'],
      ['f8d1', 'music-slash'],
      ['e5bc', 'mustache'],
      ['4e', 'n'],
      ['e1f6', 'naira-sign'],
      ['f3d2', 'napster'],
      ['f6fe', 'narwhal'],
      ['f612', 'neos'],
      ['e3ba', 'nesting-dolls'],
      ['f6ff', 'network-wired'],
      ['f22c', 'neuter'],
      ['f1ea', 'newspaper'],
      ['e1f7', 'nfc'],
      ['e530', 'nfc-directional'],
      ['e1f8', 'nfc-lock'],
      ['e1f9', 'nfc-magnifying-glass'],
      ['e1fa', 'nfc-pen'],
      ['e1fb', 'nfc-signal'],
      ['e1fc', 'nfc-slash'],
      ['e531', 'nfc-symbol'],
      ['e1fd', 'nfc-trash'],
      ['f5a8', 'nimblr'],
      ['f419', 'node'],
      ['f3d3', 'node-js'],
      ['e5bd', 'nose'],
      ['f53e', 'not-equal'],
      ['e1fe', 'notdef'],
      ['e1ff', 'note'],
      ['e200', 'note-medical'],
      ['f249', 'note-sticky'],
      ['e201', 'notebook'],
      ['e202', 'notes'],
      ['f481', 'notes-medical'],
      ['f3d4', 'npm'],
      ['f3d5', 'ns8'],
      ['f3d6', 'nutritionix'],
      ['4f', 'o'],
      ['e49c', 'object-exclude'],
      ['f247', 'object-group'],
      ['e49d', 'object-intersect'],
      ['e49e', 'object-subtract'],
      ['f248', 'object-ungroup'],
      ['e49f', 'object-union'],
      ['e3bb', 'objects-align-bottom'],
      ['e3bc', 'objects-align-center-horizontal'],
      ['e3bd', 'objects-align-center-vertical'],
      ['e3be', 'objects-align-left'],
      ['e3bf', 'objects-align-right'],
      ['e3c0', 'objects-align-top'],
      ['e3c1', 'objects-column'],
      ['f306', 'octagon'],
      ['e426', 'octagon-check'],
      ['e203', 'octagon-divide'],
      ['e204', 'octagon-exclamation'],
      ['f308', 'octagon-minus'],
      ['f301', 'octagon-plus'],
      ['f2f0', 'octagon-xmark'],
      ['e688', 'octopus'],
      ['e082', 'octopus-deploy'],
      ['f263', 'odnoklassniki'],
      ['e5c6', 'odysee'],
      ['f613', 'oil-can'],
      ['e205', 'oil-can-drip'],
      ['f614', 'oil-temperature'],
      ['e532', 'oil-well'],
      ['f510', 'old-republic'],
      ['e316', 'olive'],
      ['e317', 'olive-branch'],
      ['f679', 'om'],
      ['f67a', 'omega'],
      ['e427', 'onion'],
      ['f23d', 'opencart'],
      ['f19b', 'openid'],
      ['e62b', 'opensuse'],
      ['f26a', 'opera'],
      ['f23c', 'optin-monster'],
      ['e318', 'option'],
      ['f8d2', 'orcid'],
      ['f7b8', 'ornament'],
      ['f41a', 'open-source-initiative'],
      ['f700', 'otter'],
      ['f03b', 'outdent'],
      ['e01c', 'outlet'],
      ['e01d', 'oven'],
      ['f876', 'overline'],
      ['50', 'p'],
      ['e4a0', 'padlet'],
      ['e428', 'page'],
      ['e429', 'page-caret-down'],
      ['e42a', 'page-caret-up'],
      ['f3d7', 'page4-corporation'],
      ['f18c', 'pagelines'],
      ['f815', 'pager'],
      ['f5aa', 'paint-roller'],
      ['f1fc', 'paintbrush'],
      ['f5a9', 'paintbrush-fine'],
      ['e206', 'paintbrush-pencil'],
      ['f53f', 'palette'],
      ['f3d8', 'palfed'],
      ['f482', 'pallet'],
      ['e208', 'pallet-box'],
      ['f483', 'pallet-boxes'],
      ['e42b', 'pan-food'],
      ['e42c', 'pan-frying'],
      ['e42d', 'pancakes'],
      ['e42e', 'panel-ews'],
      ['e42f', 'panel-fire'],
      ['e209', 'panorama'],
      ['f1d8', 'paper-plane'],
      ['e20a', 'paper-plane-top'],
      ['f0c6', 'paperclip'],
      ['e3c2', 'paperclip-vertical'],
      ['f4cd', 'parachute-box'],
      ['f1dd', 'paragraph'],
      ['f878', 'paragraph-left'],
      ['e31a', 'party-bell'],
      ['e31b', 'party-horn'],
      ['f5ab', 'passport'],
      ['f0ea', 'paste'],
      ['f3d9', 'patreon'],
      ['f04c', 'pause'],
      ['f1b0', 'paw'],
      ['f702', 'paw-claws'],
      ['f701', 'paw-simple'],
      ['f1ed', 'paypal'],
      ['f67c', 'peace'],
      ['e20b', 'peach'],
      ['e430', 'peanut'],
      ['e431', 'peanuts'],
      ['e31c', 'peapod'],
      ['e20c', 'pear'],
      ['e20d', 'pedestal'],
      ['f703', 'pegasus'],
      ['f304', 'pen'],
      ['e20e', 'pen-circle'],
      ['f305', 'pen-clip'],
      ['e20f', 'pen-clip-slash'],
      ['f5ac', 'pen-fancy'],
      ['e210', 'pen-fancy-slash'],
      ['e211', 'pen-field'],
      ['e212', 'pen-line'],
      ['f5ad', 'pen-nib'],
      ['e4a1', 'pen-nib-slash'],
      ['f618', 'pen-paintbrush'],
      ['f5ae', 'pen-ruler'],
      ['e213', 'pen-slash'],
      ['e214', 'pen-swirl'],
      ['f044', 'pen-to-square'],
      ['f303', 'pencil'],
      ['e5ca', 'pencil-mechanical'],
      ['e215', 'pencil-slash'],
      ['e216', 'people'],
      ['e068', 'people-arrows'],
      ['f4ce', 'people-carry-box'],
      ['e217', 'people-dress'],
      ['e218', 'people-dress-simple'],
      ['e533', 'people-group'],
      ['e534', 'people-line'],
      ['e219', 'people-pants'],
      ['e21a', 'people-pants-simple'],
      ['e535', 'people-pulling'],
      ['e536', 'people-robbery'],
      ['e537', 'people-roof'],
      ['e21b', 'people-simple'],
      ['e432', 'pepper'],
      ['f816', 'pepper-hot'],
      ['e083', 'perbyte'],
      ['25', 'percent'],
      ['2e', 'period'],
      ['f3da', 'periscope'],
      ['f183', 'person'],
      ['e538', 'person-arrow-down-to-line'],
      ['e539', 'person-arrow-up-from-line'],
      ['f84a', 'person-biking'],
      ['f84b', 'person-biking-mountain'],
      ['f756', 'person-booth'],
      ['e53a', 'person-breastfeeding'],
      ['e53b', 'person-burst'],
      ['e53c', 'person-cane'],
      ['f4cf', 'person-carry-box'],
      ['e53d', 'person-chalkboard'],
      ['e53e', 'person-circle-check'],
      ['e53f', 'person-circle-exclamation'],
      ['e540', 'person-circle-minus'],
      ['e541', 'person-circle-plus'],
      ['e542', 'person-circle-question'],
      ['e543', 'person-circle-xmark'],
      ['f85e', 'person-digging'],
      ['f4d0', 'person-dolly'],
      ['f4d1', 'person-dolly-empty'],
      ['f470', 'person-dots-from-line'],
      ['f182', 'person-dress'],
      ['e544', 'person-dress-burst'],
      ['e607', 'person-dress-fairy'],
      ['e21c', 'person-dress-simple'],
      ['e545', 'person-drowning'],
      ['e608', 'person-fairy'],
      ['e546', 'person-falling'],
      ['e547', 'person-falling-burst'],
      ['e023', 'person-from-portal'],
      ['e548', 'person-half-dress'],
      ['e549', 'person-harassing'],
      ['f6ec', 'person-hiking'],
      ['e54a', 'person-military-pointing'],
      ['e54b', 'person-military-rifle'],
      ['e54c', 'person-military-to-person'],
      ['e21d', 'person-pinball'],
      ['f683', 'person-praying'],
      ['e31e', 'person-pregnant'],
      ['e54d', 'person-rays'],
      ['e54e', 'person-rifle'],
      ['f70c', 'person-running'],
      ['e5ff', 'person-running-fast'],
      ['e21e', 'person-seat'],
      ['e21f', 'person-seat-reclined'],
      ['e54f', 'person-shelter'],
      ['f757', 'person-sign'],
      ['e220', 'person-simple'],
      ['f7c5', 'person-skating'],
      ['f7c7', 'person-ski-jumping'],
      ['f7c8', 'person-ski-lift'],
      ['f7c9', 'person-skiing'],
      ['f7ca', 'person-skiing-nordic'],
      ['f7cb', 'person-sledding'],
      ['f7ce', 'person-snowboarding'],
      ['f7d1', 'person-snowmobiling'],
      ['f5c4', 'person-swimming'],
      ['e5a9', 'person-through-window'],
      ['e433', 'person-to-door'],
      ['e022', 'person-to-portal'],
      ['f554', 'person-walking'],
      ['e551', 'person-walking-arrow-loop-left'],
      ['e552', 'person-walking-arrow-right'],
      ['e553', 'person-walking-dashed-line-arrow-right'],
      ['e554', 'person-walking-luggage'],
      ['f29d', 'person-walking-with-cane'],
      ['e221', 'peseta-sign'],
      ['e222', 'peso-sign'],
      ['f3db', 'phabricator'],
      ['f3dc', 'phoenix-framework'],
      ['f511', 'phoenix-squadron'],
      ['f095', 'phone'],
      ['e223', 'phone-arrow-down-left'],
      ['e5be', 'phone-arrow-right'],
      ['e224', 'phone-arrow-up-right'],
      ['f879', 'phone-flip'],
      ['e225', 'phone-hangup'],
      ['e434', 'phone-intercom'],
      ['e226', 'phone-missed'],
      ['f67d', 'phone-office'],
      ['f4d2', 'phone-plus'],
      ['f8d3', 'phone-rotary'],
      ['f3dd', 'phone-slash'],
      ['f2a0', 'phone-volume'],
      ['e227', 'phone-xmark'],
      ['f87c', 'photo-film'],
      ['e228', 'photo-film-music'],
      ['f457', 'php'],
      ['f67e', 'pi'],
      ['f8d4', 'piano'],
      ['f8d5', 'piano-keyboard'],
      ['e5bf', 'pickaxe'],
      ['e435', 'pickleball'],
      ['f705', 'pie'],
      ['f2ae', 'pied-piper-logo'],
      ['f1a8', 'alternate-pied-piper-logo-(old)'],
      ['f4e5', 'pied-piper-hat-(old)'],
      ['f1a7', 'pied-piper-pp-logo-(old)'],
      ['f706', 'pig'],
      ['f4d3', 'piggy-bank'],
      ['f484', 'pills'],
      ['e3c3', 'pinata'],
      ['e229', 'pinball'],
      ['e31f', 'pineapple'],
      ['f0d2', 'pinterest'],
      ['f231', 'pinterest-p'],
      ['7c', 'pipe'],
      ['e436', 'pipe-circle-check'],
      ['e437', 'pipe-collar'],
      ['e438', 'pipe-section'],
      ['e3c4', 'pipe-smoking'],
      ['e439', 'pipe-valve'],
      ['e43a', 'pix'],
      ['e640', 'pixiv'],
      ['f817', 'pizza'],
      ['f818', 'pizza-slice'],
      ['f67f', 'place-of-worship'],
      ['f072', 'plane'],
      ['f5af', 'plane-arrival'],
      ['e555', 'plane-circle-check'],
      ['e556', 'plane-circle-exclamation'],
      ['e557', 'plane-circle-xmark'],
      ['f5b0', 'plane-departure'],
      ['f3de', 'plane-engines'],
      ['e558', 'plane-lock'],
      ['e22b', 'plane-prop'],
      ['e069', 'plane-slash'],
      ['e22c', 'plane-tail'],
      ['e22d', 'plane-up'],
      ['e22e', 'plane-up-slash'],
      ['e01f', 'planet-moon'],
      ['e020', 'planet-ringed'],
      ['e5aa', 'plant-wilt'],
      ['e43b', 'plate-utensils'],
      ['e55a', 'plate-wheat'],
      ['f04b', 'play'],
      ['e22f', 'play-pause'],
      ['f3df', 'playstation'],
      ['f1e6', 'plug'],
      ['e55b', 'plug-circle-bolt'],
      ['e55c', 'plug-circle-check'],
      ['e55d', 'plug-circle-exclamation'],
      ['e55e', 'plug-circle-minus'],
      ['e55f', 'plug-circle-plus'],
      ['e560', 'plug-circle-xmark'],
      ['2b', 'plus'],
      ['e59e', 'plus-large'],
      ['e43c', 'plus-minus'],
      ['f2ce', 'podcast'],
      ['f680', 'podium'],
      ['f758', 'podium-star'],
      ['e021', 'police-box'],
      ['f759', 'poll-people'],
      ['e43d', 'pompebled'],
      ['f2fe', 'poo'],
      ['f75a', 'poo-storm'],
      ['e3c5', 'pool-8-ball'],
      ['f619', 'poop'],
      ['f819', 'popcorn'],
      ['e43e', 'popsicle'],
      ['e43f', 'pot-food'],
      ['e440', 'potato'],
      ['f011', 'power-off'],
      ['f5b1', 'prescription'],
      ['f485', 'prescription-bottle'],
      ['f486', 'prescription-bottle-medical'],
      ['e5c0', 'prescription-bottle-pill'],
      ['f685', 'presentation-screen'],
      ['e441', 'pretzel'],
      ['f02f', 'print'],
      ['f81a', 'print-magnifying-glass'],
      ['f686', 'print-slash'],
      ['f288', 'product-hunt'],
      ['f8d6', 'projector'],
      ['e442', 'pump'],
      ['e06a', 'pump-medical'],
      ['e06b', 'pump-soap'],
      ['f707', 'pumpkin'],
      ['f3e1', 'pushed'],
      ['e443', 'puzzle'],
      ['f12e', 'puzzle-piece'],
      ['e231', 'puzzle-piece-simple'],
      ['f3e2', 'python'],
      ['51', 'q'],
      ['f1d6', 'qq'],
      ['f029', 'qrcode'],
      ['3f', 'question'],
      ['f459', 'quinscape'],
      ['f2c4', 'quora'],
      ['f10d', 'quote-left'],
      ['f10e', 'quote-right'],
      ['e234', 'quotes'],
      ['52', 'r'],
      ['f4f7', 'r-project'],
      ['f708', 'rabbit'],
      ['f709', 'rabbit-running'],
      ['e613', 'raccoon'],
      ['f45a', 'racquet'],
      ['e024', 'radar'],
      ['f7b9', 'radiation'],
      ['f8d7', 'radio'],
      ['f8d8', 'radio-tuner'],
      ['f75b', 'rainbow'],
      ['f75c', 'raindrops'],
      ['f70a', 'ram'],
      ['f4d4', 'ramp-loading'],
      ['e561', 'ranking-star'],
      ['f7bb', 'raspberry-pi'],
      ['f2d9', 'ravelry'],
      ['e025', 'raygun'],
      ['f41b', 'react'],
      ['f75d', 'reacteurope'],
      ['f4d5', 'readme'],
      ['f1d0', 'rebel-alliance'],
      ['f543', 'receipt'],
      ['f8d9', 'record-vinyl'],
      ['f2fa', 'rectangle'],
      ['f641', 'rectangle-ad'],
      ['f463', 'rectangle-barcode'],
      ['e322', 'rectangle-code'],
      ['e4a2', 'rectangle-history'],
      ['e4a3', 'rectangle-history-circle-plus'],
      ['e4a4', 'rectangle-history-circle-user'],
      ['f022', 'rectangle-list'],
      ['e235', 'rectangle-pro'],
      ['e236', 'rectangle-terminal'],
      ['f2fb', 'rectangle-vertical'],
      ['e237', 'rectangle-vertical-history'],
      ['f2fc', 'rectangle-wide'],
      ['f410', 'rectangle-xmark'],
      ['e323', 'rectangles-mixed'],
      ['f1b8', 'recycle'],
      ['f3e3', 'red-river'],
      ['f1a1', 'reddit'],
      ['f281', 'reddit-alien'],
      ['f7bc', 'redhat'],
      ['e238', 'reel'],
      ['e66f', 'reflect-both'],
      ['e664', 'reflect-horizontal'],
      ['e665', 'reflect-vertical'],
      ['e026', 'refrigerator'],
      ['f25d', 'registered'],
      ['f18b', 'renren'],
      ['f363', 'repeat'],
      ['f365', 'repeat-1'],
      ['f3e5', 'reply'],
      ['f122', 'reply-all'],
      ['e239', 'reply-clock'],
      ['f3e6', 'replyd'],
      ['f75e', 'republican'],
      ['f4f8', 'researchgate'],
      ['f3e7', 'resolving'],
      ['f7bd', 'restroom'],
      ['e23a', 'restroom-simple'],
      ['f079', 'retweet'],
      ['f5b2', 'rev'],
      ['e23b', 'rhombus'],
      ['f4d6', 'ribbon'],
      ['f356', 'right'],
      ['f2f5', 'right-from-bracket'],
      ['f347', 'right-from-line'],
      ['f362', 'right-left'],
      ['e5e1', 'right-left-large'],
      ['f30b', 'right-long'],
      ['e444', 'right-long-to-line'],
      ['f2f6', 'right-to-bracket'],
      ['f34c', 'right-to-line'],
      ['f70b', 'ring'],
      ['e5ab', 'ring-diamond'],
      ['f81b', 'rings-wedding'],
      ['f018', 'road'],
      ['e562', 'road-barrier'],
      ['e563', 'road-bridge'],
      ['e564', 'road-circle-check'],
      ['e565', 'road-circle-exclamation'],
      ['e566', 'road-circle-xmark'],
      ['e567', 'road-lock'],
      ['e568', 'road-spikes'],
      ['f544', 'robot'],
      ['e2d2', 'robot-astromech'],
      ['f135', 'rocket'],
      ['e027', 'rocket-launch'],
      ['f3e8', 'rocketchat'],
      ['f3e9', 'rockrms'],
      ['e324', 'roller-coaster'],
      ['f2f1', 'rotate'],
      ['e23c', 'rotate-exclamation'],
      ['f2ea', 'rotate-left'],
      ['e631', 'rotate-reverse'],
      ['f2f9', 'rotate-right'],
      ['f4d7', 'route'],
      ['f61a', 'route-highway'],
      ['f61b', 'route-interstate'],
      ['f8da', 'router'],
      ['f09e', 'rss'],
      ['f158', 'ruble-sign'],
      ['e569', 'rug'],
      ['e3c6', 'rugby-ball'],
      ['f545', 'ruler'],
      ['f546', 'ruler-combined'],
      ['f547', 'ruler-horizontal'],
      ['f61c', 'ruler-triangle'],
      ['f548', 'ruler-vertical'],
      ['f156', 'rupee-sign'],
      ['e23d', 'rupiah-sign'],
      ['e07a', 'rust'],
      ['f7be', 'rv'],
      ['53', 's'],
      ['f81c', 'sack'],
      ['f81d', 'sack-dollar'],
      ['e56a', 'sack-xmark'],
      ['f267', 'safari'],
      ['e445', 'sailboat'],
      ['f81e', 'salad'],
      ['f83b', 'salesforce'],
      ['e446', 'salt-shaker'],
      ['f81f', 'sandwich'],
      ['f41e', 'sass'],
      ['f7bf', 'satellite'],
      ['f7c0', 'satellite-dish'],
      ['f820', 'sausage'],
      ['f8dc', 'saxophone'],
      ['f8db', 'saxophone-fire'],
      ['f24e', 'scale-balanced'],
      ['f515', 'scale-unbalanced'],
      ['f516', 'scale-unbalanced-flip'],
      ['f61d', 'scalpel'],
      ['f61e', 'scalpel-line-dashed'],
      ['f488', 'scanner-gun'],
      ['f8f3', 'scanner-image'],
      ['f489', 'scanner-keyboard'],
      ['f48a', 'scanner-touchscreen'],
      ['f70d', 'scarecrow'],
      ['f7c1', 'scarf'],
      ['f3ea', 'schlix'],
      ['f549', 'school'],
      ['e56b', 'school-circle-check'],
      ['e56c', 'school-circle-exclamation'],
      ['e56d', 'school-circle-xmark'],
      ['e56e', 'school-flag'],
      ['e56f', 'school-lock'],
      ['f0c4', 'scissors'],
      ['f63d', 'screen-users'],
      ['e23e', 'screencast'],
      ['e570', 'screenpal'],
      ['f54a', 'screwdriver'],
      ['f7d9', 'screwdriver-wrench'],
      ['e23f', 'scribble'],
      ['f28a', 'scribd'],
      ['f70e', 'scroll'],
      ['f70f', 'scroll-old'],
      ['f6a0', 'scroll-torah'],
      ['f2f8', 'scrubber'],
      ['f710', 'scythe'],
      ['f7c2', 'sd-card'],
      ['e240', 'sd-cards'],
      ['e241', 'seal'],
      ['e242', 'seal-exclamation'],
      ['e243', 'seal-question'],
      ['f3eb', 'searchengin'],
      ['e244', 'seat-airline'],
      ['e447', 'section'],
      ['f4d8', 'seedling'],
      ['f2da', 'sellcast'],
      ['f213', 'sellsy'],
      ['3b', 'semicolon'],
      ['f87e', 'send-back'],
      ['f87f', 'send-backward'],
      ['e028', 'sensor'],
      ['e02c', 'sensor-cloud'],
      ['e02a', 'sensor-fire'],
      ['e02b', 'sensor-on'],
      ['e029', 'sensor-triangle-exclamation'],
      ['f233', 'server'],
      ['f3ec', 'servicestack'],
      ['f61f', 'shapes'],
      ['f064', 'share'],
      ['f367', 'share-all'],
      ['f14d', 'share-from-square'],
      ['f1e0', 'share-nodes'],
      ['f711', 'sheep'],
      ['e571', 'sheet-plastic'],
      ['f20b', 'shekel-sign'],
      ['f480', 'shelves'],
      ['e246', 'shelves-empty'],
      ['f132', 'shield'],
      ['e572', 'shield-cat'],
      ['f2f7', 'shield-check'],
      ['f712', 'shield-cross'],
      ['e573', 'shield-dog'],
      ['e247', 'shield-exclamation'],
      ['f3ed', 'shield-halved'],
      ['e574', 'shield-heart'],
      ['e248', 'shield-keyhole'],
      ['e249', 'shield-minus'],
      ['e24a', 'shield-plus'],
      ['e575', 'shield-quartered'],
      ['e24b', 'shield-slash'],
      ['e06c', 'shield-virus'],
      ['e24c', 'shield-xmark'],
      ['f21a', 'ship'],
      ['f553', 'shirt'],
      ['e3c7', 'shirt-long-sleeve'],
      ['e3c8', 'shirt-running'],
      ['e3c9', 'shirt-tank-top'],
      ['f214', 'shirts-in-bulk'],
      ['f821', 'shish-kebab'],
      ['f54b', 'shoe-prints'],
      ['e60c', 'shoelace'],
      ['f54f', 'shop'],
      ['e4a5', 'shop-lock'],
      ['e070', 'shop-slash'],
      ['e057', 'shopify'],
      ['f5b5', 'shopware'],
      ['f713', 'shovel'],
      ['f7c3', 'shovel-snow'],
      ['f2cc', 'shower'],
      ['e24d', 'shower-down'],
      ['f68a', 'shredder'],
      ['e448', 'shrimp'],
      ['f074', 'shuffle'],
      ['e449', 'shutters'],
      ['f197', 'shuttle-space'],
      ['f45b', 'shuttlecock'],
      ['f822', 'sickle'],
      ['e24e', 'sidebar'],
      ['e24f', 'sidebar-flip'],
      ['f68b', 'sigma'],
      ['f4d9', 'sign-hanging'],
      ['e624', 'sign-post'],
      ['e625', 'sign-posts'],
      ['e626', 'sign-posts-wrench'],
      ['f012', 'signal'],
      ['f690', 'signal-bars'],
      ['f692', 'signal-bars-fair'],
      ['f693', 'signal-bars-good'],
      ['f694', 'signal-bars-slash'],
      ['f691', 'signal-bars-weak'],
      ['f68d', 'signal-fair'],
      ['f68e', 'signal-good'],
      ['e663', 'signal-messenger'],
      ['f695', 'signal-slash'],
      ['f8dd', 'signal-stream'],
      ['e250', 'signal-stream-slash'],
      ['f68f', 'signal-strong'],
      ['f68c', 'signal-weak'],
      ['f5b7', 'signature'],
      ['e3ca', 'signature-lock'],
      ['e3cb', 'signature-slash'],
      ['f277', 'signs-post'],
      ['f7c4', 'sim-card'],
      ['e251', 'sim-cards'],
      ['f215', 'simplybuilt'],
      ['e06d', 'sink'],
      ['e02d', 'siren'],
      ['e02e', 'siren-on'],
      ['f3ee', 'sistrix'],
      ['f0e8', 'sitemap'],
      ['f512', 'sith'],
      ['e44a', 'sitrox'],
      ['f620', 'skeleton'],
      ['e5cb', 'skeleton-ribs'],
      ['f7c6', 'sketch'],
      ['e3cc', 'ski-boot'],
      ['e3cd', 'ski-boot-ski'],
      ['f54c', 'skull'],
      ['f8de', 'skull-cow'],
      ['f714', 'skull-crossbones'],
      ['f216', 'skyatlas'],
      ['f17e', 'skype'],
      ['f198', 'slack-logo'],
      ['f715', 'slash'],
      ['5c', 'slash-back'],
      ['2f', 'slash-forward'],
      ['f7cc', 'sleigh'],
      ['e252', 'slider'],
      ['f1de', 'sliders'],
      ['e253', 'sliders-simple'],
      ['f3f1', 'sliders-up'],
      ['f1e7', 'slideshare'],
      ['e3ce', 'slot-machine'],
      ['f75f', 'smog'],
      ['f760', 'smoke'],
      ['f48d', 'smoking'],
      ['f716', 'snake'],
      ['f2ab', 'snapchat'],
      ['f880', 'snooze'],
      ['f761', 'snow-blowing'],
      ['f2dc', 'snowflake'],
      ['e5c1', 'snowflake-droplets'],
      ['f7cf', 'snowflakes'],
      ['f7d0', 'snowman'],
      ['f79b', 'snowman-head'],
      ['f7d2', 'snowplow'],
      ['e06e', 'soap'],
      ['f696', 'socks'],
      ['e400', 'soft-serve'],
      ['f5ba', 'solar-panel'],
      ['e02f', 'solar-system'],
      ['f0dc', 'sort'],
      ['f0dd', 'sort-down'],
      ['f0de', 'sort-up'],
      ['f1be', 'soundcloud'],
      ['f7d3', 'sourcetree'],
      ['f5bb', 'spa'],
      ['e5ac', 'space-awesome'],
      ['e033', 'space-station-moon'],
      ['e034', 'space-station-moon-construction'],
      ['f2f4', 'spade'],
      ['f67b', 'spaghetti-monster-flying'],
      ['e5d6', 'sparkle'],
      ['f890', 'sparkles'],
      ['f3f3', 'speakap'],
      ['f8df', 'speaker'],
      ['f83c', 'speaker-deck'],
      ['f8e0', 'speakers'],
      ['f891', 'spell-check'],
      ['f717', 'spider'],
      ['f718', 'spider-black-widow'],
      ['f719', 'spider-web'],
      ['f110', 'spinner'],
      ['e62a', 'spinner-scale'],
      ['f3f4', 'spinner-third'],
      ['e254', 'split'],
      ['f5bc', 'splotch'],
      ['f2e5', 'spoon'],
      ['e44b', 'sportsball'],
      ['f1bc', 'spotify'],
      ['f5bd', 'spray-can'],
      ['f5d0', 'spray-can-sparkles'],
      ['e035', 'sprinkler'],
      ['e44c', 'sprinkler-ceiling'],
      ['f0c8', 'square'],
      ['e255', 'square-0'],
      ['e256', 'square-1'],
      ['e257', 'square-2'],
      ['e258', 'square-3'],
      ['e259', 'square-4'],
      ['e25a', 'square-5'],
      ['e25b', 'square-6'],
      ['e25c', 'square-7'],
      ['e25d', 'square-8'],
      ['e25e', 'square-9'],
      ['e25f', 'square-a'],
      ['e44d', 'square-a-lock'],
      ['e260', 'square-ampersand'],
      ['f339', 'square-arrow-down'],
      ['e261', 'square-arrow-down-left'],
      ['e262', 'square-arrow-down-right'],
      ['f33a', 'square-arrow-left'],
      ['f33b', 'square-arrow-right'],
      ['f33c', 'square-arrow-up'],
      ['e263', 'square-arrow-up-left'],
      ['f14c', 'square-arrow-up-right'],
      ['e264', 'square-b'],
      ['f1b5', 'square-behance'],
      ['e265', 'square-bolt'],
      ['e266', 'square-c'],
      ['f150', 'square-caret-down'],
      ['f191', 'square-caret-left'],
      ['f152', 'square-caret-right'],
      ['f151', 'square-caret-up'],
      ['f14a', 'square-check'],
      ['f329', 'square-chevron-down'],
      ['f32a', 'square-chevron-left'],
      ['f32b', 'square-chevron-right'],
      ['f32c', 'square-chevron-up'],
      ['e267', 'square-code'],
      ['e268', 'square-d'],
      ['e269', 'square-dashed'],
      ['e5c2', 'square-dashed-circle-plus'],
      ['e26a', 'square-divide'],
      ['f2e9', 'square-dollar'],
      ['f350', 'square-down'],
      ['e26b', 'square-down-left'],
      ['e26c', 'square-down-right'],
      ['f397', 'square-dribbble'],
      ['e26d', 'square-e'],
      ['e26e', 'square-ellipsis'],
      ['e26f', 'square-ellipsis-vertical'],
      ['f199', 'square-envelope'],
      ['f321', 'square-exclamation'],
      ['e270', 'square-f'],
      ['f082', 'square-facebook'],
      ['e5ad', 'square-font-awesome'],
      ['f35c', 'square-font-awesome-stroke'],
      ['f49b', 'square-fragile'],
      ['f45c', 'square-full'],
      ['e271', 'square-g'],
      ['f1d2', 'square-git'],
      ['f092', 'square-github'],
      ['e5ae', 'square-gitlab'],
      ['f0d4', 'square-google-plus'],
      ['f0fd', 'square-h'],
      ['f3af', 'square-hacker-news'],
      ['f4c8', 'square-heart'],
      ['e272', 'square-i'],
      ['f30f', 'square-info'],
      ['e055', 'square-instagram'],
      ['e273', 'square-j'],
      ['f3b9', 'square-js'],
      ['e274', 'square-k'],
      ['e488', 'square-kanban'],
      ['e275', 'square-l'],
      ['f203', 'square-lastfm'],
      ['f351', 'square-left'],
      ['e62e', 'square-letterboxd'],
      ['e489', 'square-list'],
      ['e276', 'square-m'],
      ['f146', 'square-minus'],
      ['e277', 'square-n'],
      ['e576', 'square-nfi'],
      ['e278', 'square-o'],
      ['f264', 'square-odnoklassniki'],
      ['e279', 'square-p'],
      ['f540', 'square-parking'],
      ['f617', 'square-parking-slash'],
      ['f14b', 'square-pen'],
      ['e577', 'square-person-confined'],
      ['f098', 'square-phone'],
      ['f87b', 'square-phone-flip'],
      ['e27a', 'square-phone-hangup'],
      ['e01e', 'pied-piper-square-logo-(old)'],
      ['f0d3', 'square-pinterest'],
      ['f0fe', 'square-plus'],
      ['f682', 'square-poll-horizontal'],
      ['f681', 'square-poll-vertical'],
      ['e27b', 'square-q'],
      ['e44e', 'square-quarters'],
      ['f2fd', 'square-question'],
      ['e329', 'square-quote'],
      ['e27c', 'square-r'],
      ['f1a2', 'square-reddit'],
      ['f352', 'square-right'],
      ['e44f', 'square-ring'],
      ['f697', 'square-root'],
      ['f698', 'square-root-variable'],
      ['f143', 'square-rss'],
      ['e27d', 'square-s'],
      ['f1e1', 'square-share-nodes'],
      ['f3f0', 'square-sliders'],
      ['f3f2', 'square-sliders-vertical'],
      ['e27e', 'square-small'],
      ['f2ad', 'snapchat-square'],
      ['e27f', 'square-star'],
      ['f1b7', 'square-steam'],
      ['e280', 'square-t'],
      ['e32a', 'square-terminal'],
      ['f49f', 'square-this-way-up'],
      ['e619', 'square-threads'],
      ['f174', 'square-tumblr'],
      ['f081', 'square-twitter'],
      ['e281', 'square-u'],
      ['f353', 'square-up'],
      ['e282', 'square-up-left'],
      ['f360', 'square-up-right'],
      ['e67c', 'square-upwork'],
      ['e283', 'square-user'],
      ['e284', 'square-v'],
      ['f2aa', 'square-viadeo'],
      ['f194', 'square-vimeo'],
      ['e578', 'square-virus'],
      ['e285', 'square-w'],
      ['e683', 'square-web-awesome'],
      ['e684', 'square-web-awesome-stroke'],
      ['f40c', 'square-whatsapp'],
      ['e286', 'square-x'],
      ['e61a', 'square-x-twitter'],
      ['f169', 'square-xing'],
      ['f2d3', 'square-xmark'],
      ['e287', 'square-y'],
      ['f431', 'square-youtube'],
      ['e288', 'square-z'],
      ['f5be', 'squarespace'],
      ['e450', 'squid'],
      ['f71a', 'squirrel'],
      ['f18d', 'stack-exchange'],
      ['f16c', 'stack-overflow'],
      ['f842', 'stackpath'],
      ['f71b', 'staff'],
      ['e579', 'staff-snake'],
      ['e289', 'stairs'],
      ['f5bf', 'stamp'],
      ['e28a', 'standard-definition'],
      ['e5af', 'stapler'],
      ['f005', 'star'],
      ['f699', 'star-and-crescent'],
      ['f7d4', 'star-christmas'],
      ['f2f3', 'star-exclamation'],
      ['f089', 'star-half'],
      ['f5c0', 'star-half-stroke'],
      ['f69a', 'star-of-david'],
      ['f621', 'star-of-life'],
      ['e28b', 'star-sharp'],
      ['e28c', 'star-sharp-half'],
      ['e28d', 'star-sharp-half-stroke'],
      ['e036', 'star-shooting'],
      ['e037', 'starfighter'],
      ['e038', 'starfighter-twin-ion-engine'],
      ['e28e', 'starfighter-twin-ion-engine-advanced'],
      ['f762', 'stars'],
      ['e039', 'starship'],
      ['e03a', 'starship-freighter'],
      ['f3f5', 'staylinked'],
      ['f824', 'steak'],
      ['f1b6', 'steam'],
      ['f3f6', 'steam-symbol'],
      ['f622', 'steering-wheel'],
      ['f154', 'sterling-sign'],
      ['f0f1', 'stethoscope'],
      ['f3f7', 'sticker-mule'],
      ['f7d5', 'stocking'],
      ['f623', 'stomach'],
      ['f04d', 'stop'],
      ['f2f2', 'stopwatch'],
      ['e06f', 'stopwatch-20'],
      ['f54e', 'store'],
      ['e4a6', 'store-lock'],
      ['e071', 'store-slash'],
      ['f428', 'strava'],
      ['e32b', 'strawberry'],
      ['f21d', 'street-view'],
      ['f825', 'stretcher'],
      ['f0cc', 'strikethrough'],
      ['f429', 'stripe'],
      ['f42a', 'stripe-s'],
      ['f551', 'stroopwafel'],
      ['e5c7', 'stubber'],
      ['f3f8', 'studio-vinari'],
      ['f1a4', 'stumbleupon-logo'],
      ['f1a3', 'stumbleupon-circle'],
      ['f12c', 'subscript'],
      ['e60f', 'subtitles'],
      ['e610', 'subtitles-slash'],
      ['f0f2', 'suitcase'],
      ['f0fa', 'suitcase-medical'],
      ['f5c1', 'suitcase-rolling'],
      ['f185', 'sun'],
      ['e28f', 'sun-bright'],
      ['f763', 'sun-cloud'],
      ['f764', 'sun-dust'],
      ['f765', 'sun-haze'],
      ['e57a', 'sun-plant-wilt'],
      ['f892', 'sunglasses'],
      ['f766', 'sunrise'],
      ['f767', 'sunset'],
      ['f2dd', 'superpowers'],
      ['f12b', 'superscript'],
      ['f3f9', 'supple'],
      ['f7d6', 'suse'],
      ['e48a', 'sushi'],
      ['e48b', 'sushi-roll'],
      ['e609', 'swap'],
      ['e60a', 'swap-arrows'],
      ['f5c3', 'swatchbook'],
      ['f8e1', 'swift'],
      ['f71c', 'sword'],
      ['e03b', 'sword-laser'],
      ['e03c', 'sword-laser-alt'],
      ['f71d', 'swords'],
      ['e03d', 'swords-laser'],
      ['f86e', 'symbols'],
      ['f83d', 'symfony'],
      ['f69b', 'synagogue'],
      ['f48e', 'syringe'],
      ['54', 't'],
      ['e629', 't-rex'],
      ['f0ce', 'table'],
      ['f00a', 'table-cells'],
      ['e678', 'table-cells-column-lock'],
      ['e690', 'table-cells-column-unlock'],
      ['f009', 'table-cells-large'],
      ['e679', 'table-cells-lock'],
      ['e67a', 'table-cells-row-lock'],
      ['e691', 'table-cells-row-unlock'],
      ['e692', 'table-cells-unlock'],
      ['f0db', 'table-columns'],
      ['e290', 'table-layout'],
      ['f00b', 'table-list'],
      ['e32d', 'table-picnic'],
      ['e291', 'table-pivot'],
      ['e292', 'table-rows'],
      ['f45d', 'table-tennis-paddle-ball'],
      ['e293', 'table-tree'],
      ['f3fb', 'tablet'],
      ['f10a', 'tablet-button'],
      ['f48f', 'tablet-rugged'],
      ['f3fc', 'tablet-screen'],
      ['f3fa', 'tablet-screen-button'],
      ['f490', 'tablets'],
      ['f566', 'tachograph-digital'],
      ['f826', 'taco'],
      ['f02b', 'tag'],
      ['f02c', 'tags'],
      ['f69c', 'tally'],
      ['e294', 'tally-1'],
      ['e295', 'tally-2'],
      ['e296', 'tally-3'],
      ['e297', 'tally-4'],
      ['e451', 'tamale'],
      ['e452', 'tank-water'],
      ['f4db', 'tape'],
      ['e57b', 'tarp'],
      ['e57c', 'tarp-droplet'],
      ['f1ba', 'taxi'],
      ['e298', 'taxi-bus'],
      ['f4f9', 'teamspeak'],
      ['e3cf', 'teddy-bear'],
      ['f62e', 'teeth'],
      ['f62f', 'teeth-open'],
      ['f2c6', 'telegram'],
      ['e03e', 'telescope'],
      ['e03f', 'temperature-arrow-down'],
      ['e040', 'temperature-arrow-up'],
      ['f2cb', 'temperature-empty'],
      ['f2c7', 'temperature-full'],
      ['f2c9', 'temperature-half'],
      ['f769', 'temperature-high'],
      ['e299', 'temperature-list'],
      ['f76b', 'temperature-low'],
      ['f2ca', 'temperature-quarter'],
      ['f768', 'temperature-snow'],
      ['f76a', 'temperature-sun'],
      ['f2c8', 'temperature-three-quarters'],
      ['f1d5', 'tencent-weibo'],
      ['f7d7', 'tenge-sign'],
      ['f45e', 'tennis-ball'],
      ['e57d', 'tent'],
      ['e57e', 'tent-arrow-down-to-line'],
      ['e57f', 'tent-arrow-left-right'],
      ['e580', 'tent-arrow-turn-left'],
      ['e581', 'tent-arrows-down'],
      ['e627', 'tent-double-peak'],
      ['e582', 'tents'],
      ['f120', 'terminal'],
      ['f893', 'text'],
      ['f034', 'text-height'],
      ['f894', 'text-size'],
      ['f87d', 'text-slash'],
      ['f035', 'text-width'],
      ['f69d', 'the-red-yeti'],
      ['f5c6', 'themeco'],
      ['f2b2', 'themeisle'],
      ['f491', 'thermometer'],
      ['f69e', 'theta'],
      ['f731', 'think-peaks'],
      ['e32e', 'thought-bubble'],
      ['e618', 'threads'],
      ['f165', 'thumbs-down'],
      ['f164', 'thumbs-up'],
      ['f08d', 'thumbtack'],
      ['e68f', 'thumbtack-slash'],
      ['e32f', 'tick'],
      ['f145', 'ticket'],
      ['e29a', 'ticket-airline'],
      ['e63e', 'ticket-perforated'],
      ['f3ff', 'ticket-simple'],
      ['e658', 'tickets'],
      ['e29b', 'tickets-airline'],
      ['e63f', 'tickets-perforated'],
      ['e659', 'tickets-simple'],
      ['e07b', 'tiktok'],
      ['7e', 'tilde'],
      ['e29c', 'timeline'],
      ['e29d', 'timeline-arrow'],
      ['e29e', 'timer'],
      ['f631', 'tire'],
      ['f632', 'tire-flat'],
      ['f633', 'tire-pressure-warning'],
      ['f634', 'tire-rugged'],
      ['e5b0', 'toggle-large-off'],
      ['e5b1', 'toggle-large-on'],
      ['f204', 'toggle-off'],
      ['f205', 'toggle-on'],
      ['f7d8', 'toilet'],
      ['f71e', 'toilet-paper'],
      ['f71f', 'toilet-paper-blank'],
      ['e29f', 'toilet-paper-blank-under'],
      ['e5b2', 'toilet-paper-check'],
      ['e072', 'toilet-paper-slash'],
      ['e2a0', 'toilet-paper-under'],
      ['e2a1', 'toilet-paper-under-slash'],
      ['e5b3', 'toilet-paper-xmark'],
      ['e583', 'toilet-portable'],
      ['e584', 'toilets-portable'],
      ['e330', 'tomato'],
      ['f720', 'tombstone'],
      ['f721', 'tombstone-blank'],
      ['f552', 'toolbox'],
      ['f5c9', 'tooth'],
      ['f635', 'toothbrush'],
      ['f6a1', 'torii-gate'],
      ['f76f', 'tornado'],
      ['f519', 'tower-broadcast'],
      ['e585', 'tower-cell'],
      ['e2a2', 'tower-control'],
      ['e586', 'tower-observation'],
      ['f722', 'tractor'],
      ['f513', 'trade-federation'],
      ['f25c', 'trademark'],
      ['f636', 'traffic-cone'],
      ['f637', 'traffic-light'],
      ['f638', 'traffic-light-go'],
      ['f639', 'traffic-light-slow'],
      ['f63a', 'traffic-light-stop'],
      ['e041', 'trailer'],
      ['f238', 'train'],
      ['f239', 'train-subway'],
      ['e2a3', 'train-subway-tunnel'],
      ['e453', 'train-track'],
      ['e5b4', 'train-tram'],
      ['e454', 'train-tunnel'],
      ['e2a4', 'transformer-bolt'],
      ['f225', 'transgender'],
      ['e042', 'transporter'],
      ['e043', 'transporter-1'],
      ['e044', 'transporter-2'],
      ['e045', 'transporter-3'],
      ['e2a5', 'transporter-4'],
      ['e2a6', 'transporter-5'],
      ['e2a7', 'transporter-6'],
      ['e2a8', 'transporter-7'],
      ['e046', 'transporter-empty'],
      ['f1f8', 'trash'],
      ['f829', 'trash-arrow-up'],
      ['f2ed', 'trash-can'],
      ['f82a', 'trash-can-arrow-up'],
      ['e2a9', 'trash-can-check'],
      ['e2aa', 'trash-can-clock'],
      ['e2ab', 'trash-can-list'],
      ['e2ac', 'trash-can-plus'],
      ['e2ad', 'trash-can-slash'],
      ['f896', 'trash-can-undo'],
      ['e2ae', 'trash-can-xmark'],
      ['e2af', 'trash-check'],
      ['e2b0', 'trash-clock'],
      ['e2b1', 'trash-list'],
      ['e2b2', 'trash-plus'],
      ['e2b3', 'trash-slash'],
      ['f895', 'trash-undo'],
      ['e2b4', 'trash-xmark'],
      ['f723', 'treasure-chest'],
      ['f1bb', 'tree'],
      ['f7db', 'tree-christmas'],
      ['e587', 'tree-city'],
      ['f400', 'tree-deciduous'],
      ['f7dc', 'tree-decorated'],
      ['f7dd', 'tree-large'],
      ['f82b', 'tree-palm'],
      ['f724', 'trees'],
      ['f181', 'trello'],
      ['f2ec', 'triangle'],
      ['f071', 'triangle-exclamation'],
      ['f8e2', 'triangle-instrument'],
      ['f85d', 'triangle-person-digging'],
      ['e5c3', 'tricycle'],
      ['e5c4', 'tricycle-adult'],
      ['e588', 'trillium'],
      ['f091', 'trophy'],
      ['f2eb', 'trophy-star'],
      ['e589', 'trowel'],
      ['e58a', 'trowel-bricks'],
      ['f0d1', 'truck'],
      ['e58b', 'truck-arrow-right'],
      ['e3d0', 'truck-bolt'],
      ['f48c', 'truck-clock'],
      ['f4dc', 'truck-container'],
      ['e2b5', 'truck-container-empty'],
      ['e58c', 'truck-droplet'],
      ['f48b', 'truck-fast'],
      ['e58d', 'truck-field'],
      ['e58e', 'truck-field-un'],
      ['e65a', 'truck-fire'],
      ['e2b6', 'truck-flatbed'],
      ['e2b7', 'truck-front'],
      ['e657', 'truck-ladder'],
      ['f0f9', 'truck-medical'],
      ['f63b', 'truck-monster'],
      ['f4df', 'truck-moving'],
      ['f63c', 'truck-pickup'],
      ['e58f', 'truck-plane'],
      ['f7de', 'truck-plow'],
      ['f4e0', 'truck-ramp'],
      ['f4de', 'truck-ramp-box'],
      ['f4dd', 'truck-ramp-couch'],
      ['e2b8', 'truck-tow'],
      ['e628', 'truck-utensils'],
      ['f8e3', 'trumpet'],
      ['f1e4', 'tty'],
      ['e2b9', 'tty-answer'],
      ['e2ba', 'tugrik-sign'],
      ['f173', 'tumblr'],
      ['f725', 'turkey'],
      ['e2bb', 'turkish-lira-sign'],
      ['f3be', 'turn-down'],
      ['e331', 'turn-down-left'],
      ['e455', 'turn-down-right'],
      ['e636', 'turn-left'],
      ['e637', 'turn-left-down'],
      ['e638', 'turn-left-up'],
      ['e639', 'turn-right'],
      ['f3bf', 'turn-up'],
      ['f8e4', 'turntable'],
      ['f726', 'turtle'],
      ['f26c', 'tv'],
      ['f8e6', 'tv-music'],
      ['f401', 'tv-retro'],
      ['f1e8', 'twitch'],
      ['f099', 'twitter'],
      ['f8e7', 'typewriter'],
      ['f42b', 'typo3'],
      ['55', 'u'],
      ['f402', 'uber'],
      ['f7df', 'ubuntu'],
      ['e047', 'ufo'],
      ['e048', 'ufo-beam'],
      ['f403', 'uikit'],
      ['f8e8', 'umbraco'],
      ['f0e9', 'umbrella'],
      ['f5ca', 'umbrella-beach'],
      ['e2bc', 'umbrella-simple'],
      ['e084', 'uncharted-software'],
      ['f0cd', 'underline'],
      ['f727', 'unicorn'],
      ['e3d1', 'uniform-martial-arts'],
      ['f6a2', 'union'],
      ['f404', 'uniregistry'],
      ['e049', 'unity-3d'],
      ['f29a', 'universal-access'],
      ['f09c', 'unlock'],
      ['f13e', 'unlock-keyhole'],
      ['e07c', 'unsplash'],
      ['f405', 'untappd'],
      ['f357', 'up'],
      ['f338', 'up-down'],
      ['f0b2', 'up-down-left-right'],
      ['e590', 'up-from-bracket'],
      ['e456', 'up-from-dotted-line'],
      ['f346', 'up-from-line'],
      ['e2bd', 'up-left'],
      ['f30c', 'up-long'],
      ['e2be', 'up-right'],
      ['f424', 'up-right-and-down-left-from-center'],
      ['f35d', 'up-right-from-square'],
      ['e66e', 'up-to-bracket'],
      ['e457', 'up-to-dotted-line'],
      ['f34d', 'up-to-line'],
      ['f093', 'upload'],
      ['f7e0', 'ups'],
      ['e641', 'upwork'],
      ['f287', 'usb'],
      ['f8e9', 'usb-drive'],
      ['f007', 'user'],
      ['e04a', 'user-alien'],
      ['f4fb', 'user-astronaut'],
      ['e689', 'user-beard-bolt'],
      ['e2bf', 'user-bounty-hunter'],
      ['f4fc', 'user-check'],
      ['e3d2', 'user-chef'],
      ['f4fd', 'user-clock'],
      ['f8ea', 'user-cowboy'],
      ['f6a4', 'user-crown'],
      ['f0f0', 'user-doctor'],
      ['e458', 'user-doctor-hair'],
      ['e459', 'user-doctor-hair-long'],
      ['f82e', 'user-doctor-message'],
      ['f4fe', 'user-gear'],
      ['f501', 'user-graduate'],
      ['f500', 'user-group'],
      ['f6a5', 'user-group-crown'],
      ['e603', 'user-group-simple'],
      ['e45a', 'user-hair'],
      ['e3d3', 'user-hair-buns'],
      ['e45b', 'user-hair-long'],
      ['e45c', 'user-hair-mullet'],
      ['f82d', 'user-headset'],
      ['f82c', 'user-helmet-safety'],
      ['e68a', 'user-hoodie'],
      ['f728', 'user-injured'],
      ['f406', 'user-large'],
      ['f4fa', 'user-large-slash'],
      ['f502', 'user-lock'],
      ['e5c5', 'user-magnifying-glass'],
      ['f503', 'user-minus'],
      ['f8eb', 'user-music'],
      ['f504', 'user-ninja'],
      ['f82f', 'user-nurse'],
      ['e45d', 'user-nurse-hair'],
      ['e45e', 'user-nurse-hair-long'],
      ['f4ff', 'user-pen'],
      ['e2c0', 'user-pilot'],
      ['e2c1', 'user-pilot-tie'],
      ['f234', 'user-plus'],
      ['e333', 'user-police'],
      ['e334', 'user-police-tie'],
      ['e04b', 'user-robot'],
      ['e4a7', 'user-robot-xmarks'],
      ['f21b', 'user-secret'],
      ['e2c2', 'user-shakespeare'],
      ['f505', 'user-shield'],
      ['f506', 'user-slash'],
      ['f507', 'user-tag'],
      ['f508', 'user-tie'],
      ['e45f', 'user-tie-hair'],
      ['e460', 'user-tie-hair-long'],
      ['e058', 'user-unlock'],
      ['e04c', 'user-visor'],
      ['e461', 'user-vneck'],
      ['e462', 'user-vneck-hair'],
      ['e463', 'user-vneck-hair-long'],
      ['f235', 'user-xmark'],
      ['f0c0', 'users'],
      ['e591', 'users-between-lines'],
      ['f509', 'users-gear'],
      ['e592', 'users-line'],
      ['f830', 'users-medical'],
      ['e593', 'users-rays'],
      ['e594', 'users-rectangle'],
      ['e073', 'users-slash'],
      ['e595', 'users-viewfinder'],
      ['f7e1', 'united-states-postal-service'],
      ['f407', 'us-sunnah-foundation'],
      ['f2e7', 'utensils'],
      ['e464', 'utensils-slash'],
      ['e2c3', 'utility-pole'],
      ['e2c4', 'utility-pole-double'],
      ['56', 'v'],
      ['f408', 'vaadin'],
      ['e04d', 'vacuum'],
      ['e04e', 'vacuum-robot'],
      ['f6a6', 'value-absolute'],
      ['f5b6', 'van-shuttle'],
      ['e2c5', 'vault'],
      ['e2c6', 'vector-circle'],
      ['e2c7', 'vector-polygon'],
      ['f5cb', 'vector-square'],
      ['e465', 'vent-damper'],
      ['f221', 'venus'],
      ['f226', 'venus-double'],
      ['f228', 'venus-mars'],
      ['e085', 'vest'],
      ['e086', 'vest-patches'],
      ['f237', 'viacoin'],
      ['f2a9', 'viadeo'],
      ['f492', 'vial'],
      ['e596', 'vial-circle-check'],
      ['e597', 'vial-virus'],
      ['f493', 'vials'],
      ['f409', 'viber'],
      ['f03d', 'video'],
      ['e2c8', 'video-arrow-down-left'],
      ['e2c9', 'video-arrow-up-right'],
      ['f4e1', 'video-plus'],
      ['f4e2', 'video-slash'],
      ['f6a7', 'vihara'],
      ['f40a', 'vimeo'],
      ['f27d', 'vimeo'],
      ['f1ca', 'vine'],
      ['f8ed', 'violin'],
      ['e074', 'virus'],
      ['e4a8', 'virus-covid'],
      ['e4a9', 'virus-covid-slash'],
      ['e075', 'virus-slash'],
      ['e076', 'viruses'],
      ['f189', 'vk'],
      ['f40b', 'vnv'],
      ['f897', 'voicemail'],
      ['f770', 'volcano'],
      ['f45f', 'volleyball'],
      ['f6a8', 'volume'],
      ['f028', 'volume-high'],
      ['f027', 'volume-low'],
      ['f026', 'volume-off'],
      ['f2e2', 'volume-slash'],
      ['f6a9', 'volume-xmark'],
      ['f729', 'vr-cardboard'],
      ['f41f', 'vuejs'],
      ['57', 'w'],
      ['e466', 'waffle'],
      ['f8ee', 'wagon-covered'],
      ['f831', 'walker'],
      ['f8ef', 'walkie-talkie'],
      ['f555', 'wallet'],
      ['f72a', 'wand'],
      ['f0d0', 'wand-magic'],
      ['e2ca', 'wand-magic-sparkles'],
      ['f72b', 'wand-sparkles'],
      ['f494', 'warehouse'],
      ['f495', 'warehouse-full'],
      ['f898', 'washing-machine'],
      ['f2e1', 'watch'],
      ['e2cb', 'watch-apple'],
      ['f8f0', 'watch-calculator'],
      ['f63e', 'watch-fitness'],
      ['e2cc', 'watch-smart'],
      ['e087', 'watchman-monitoring'],
      ['f773', 'water'],
      ['f774', 'water-arrow-down'],
      ['f775', 'water-arrow-up'],
      ['f5c5', 'water-ladder'],
      ['e337', 'watermelon-slice'],
      ['e65b', 'wave'],
      ['f5f8', 'wave-pulse'],
      ['f899', 'wave-sine'],
      ['f83e', 'wave-square'],
      ['f89a', 'wave-triangle'],
      ['f8f1', 'waveform'],
      ['f8f2', 'waveform-lines'],
      ['e65d', 'waves-sine'],
      ['f83f', 'waze'],
      ['e682', 'web-awesome'],
      ['e65c', 'webflow'],
      ['e5d5', 'webhook'],
      ['f5cc', 'weebly'],
      ['f18a', 'weibo'],
      ['f5cd', 'weight-hanging'],
      ['f496', 'weight-scale'],
      ['f1d7', 'weixin-(wechat)'],
      ['f72c', 'whale'],
      ['f232', "what's-app"],
      ['f72d', 'wheat'],
      ['e2cd', 'wheat-awn'],
      ['e598', 'wheat-awn-circle-exclamation'],
      ['e338', 'wheat-awn-slash'],
      ['e339', 'wheat-slash'],
      ['f193', 'wheelchair'],
      ['e2ce', 'wheelchair-move'],
      ['f7a0', 'whiskey-glass'],
      ['f7a1', 'whiskey-glass-ice'],
      ['f460', 'whistle'],
      ['f40d', 'whmcs'],
      ['f1eb', 'wifi'],
      ['e2cf', 'wifi-exclamation'],
      ['f6ab', 'wifi-fair'],
      ['f6ac', 'wifi-slash'],
      ['f6aa', 'wifi-weak'],
      ['f266', 'wikipedia-w'],
      ['f72e', 'wind'],
      ['f89b', 'wind-turbine'],
      ['f776', 'wind-warning'],
      ['f40e', 'window'],
      ['f40f', 'window-flip'],
      ['e04f', 'window-frame'],
      ['e050', 'window-frame-open'],
      ['f2d0', 'window-maximize'],
      ['f2d1', 'window-minimize'],
      ['f2d2', 'window-restore'],
      ['f17a', 'windows'],
      ['f777', 'windsock'],
      ['f72f', 'wine-bottle'],
      ['f4e3', 'wine-glass'],
      ['f4bb', 'wine-glass-crack'],
      ['f5ce', 'wine-glass-empty'],
      ['e2d0', 'wirsindhandwerk'],
      ['f5cf', 'wix'],
      ['f730', 'wizards-of-the-coast'],
      ['e088', 'wodu'],
      ['f514', 'wolf-pack-battalion'],
      ['f159', 'won-sign'],
      ['f19a', 'wordpress-logo'],
      ['f411', 'wordpress-simple'],
      ['e599', 'worm'],
      ['f297', 'wpbeginner'],
      ['f2de', 'wpexplorer'],
      ['f298', 'wpforms'],
      ['f3e4', 'wpressr'],
      ['f7e2', 'wreath'],
      ['e5d2', 'wreath-laurel'],
      ['f0ad', 'wrench'],
      ['e2d1', 'wrench-simple'],
      ['58', 'x'],
      ['f497', 'x-ray'],
      ['e61b', 'x-twitter'],
      ['f412', 'xbox'],
      ['f168', 'xing'],
      ['f00d', 'xmark'],
      ['e59b', 'xmark-large'],
      ['f771', 'xmark-to-slot'],
      ['e59a', 'xmarks-lines'],
      ['59', 'y'],
      ['f23b', 'y-combinator'],
      ['f19e', 'yahoo-logo'],
      ['f840', 'yammer'],
      ['f413', 'yandex'],
      ['f414', 'yandex-international'],
      ['f7e3', 'yarn'],
      ['f1e9', 'yelp'],
      ['f157', 'yen-sign'],
      ['f6ad', 'yin-yang'],
      ['f2b1', 'yoast'],
      ['f167', 'youtube'],
      ['5a', 'z'],
      ['f63f', 'zhihu'],
    ]);
  }

  public getIconName(unicode: string): string | undefined {
    return this.iconMap.get(unicode);
  }
}
